// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* .dashboard-container {
    padding-top: 80px; 
    min-height: 100vh;
    background-color: #f5f5f5;
}

.dashboard-main {
    max-width: 1200px;
margin-top: 200px;
margin-left: 200px;
    padding: 20px;
} */
.header-area{
    background:black;
}
/* .dashboard-content {
    background: white;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
} */

.recommendations-button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    margin-left:1350px;
    cursor: pointer;
    font-size: 16px;
}

.edit-questionnaire-button:hover {
    background-color: #0056b3;
}
.edit-questionnaire-button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    /* margin-left: 600px; */
    /* font-size: larger; */
    font-weight: 1000;
}

.recommendations-button:hover {
    background-color: #0056b3;
}
.main-heading {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 300px;
    font-family: Noto Serif Georgian;
    font-size: 50px;
    font-weight: 1000; 
    color: rgb(46, 119, 176);
    text-align: center;
    line-height: 1.5;
    border-radius: 0px;
    opacity: 1;
}
.profile-main-heading {
    text-align: center;
    margin-bottom: 30px;
    font-family: Noto Serif Georgian;
    font-size: 50px;
    font-weight: 1000; 
    color: rgb(46, 119, 176);
    text-align: center;
    line-height: 1.5;
    border-radius: 0px;
    opacity: 1;
}

.questionnaire-summary-box {
    /* width: 1500px !important; */
    /* height: 400px; */
    /* background-color: #007bff; */
    border-radius: 15px;
    border:6px solid #007bff;
    padding: 20px;
    margin: 20px auto;
    
}
.profile-summary-box {
    /* width: 1500px !important; */
    height: 565px; /* Increased height to accommodate more content */
    border-radius: 15px;
    border: 6px solid #007bff;
    padding: 20px;
    margin: 20px auto;
}

.questionnaire-summary-box h3 {
    text-align: center;
    margin-bottom: 30px;
}
.profile-summary-box h3 {
    text-align: center;
    margin-bottom: 30px;
}
.questionnaire-details {
    padding: 20px;
    justify-self: center;
    
}
.profile-details {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Create two columns */
    gap: 10px;
    max-height: 400px;
    overflow-y: auto; /* Add scrolling if content exceeds height */
    /* margin-left: 263px; */
}
.profile-details p {
    margin: 10px 0;
    font-size: 16px;
    display: flex;
    justify-content: left;
    align-items: center;
}

.profile-details p strong {
    min-width: 150px;
    text-align: left;
    margin-right: 15px;
    color: #2c3e50;
    font-weight: 500;
}

.questionnaire-details p {
    margin: 15px 0;
    font-size: 18px;
}
.profile-summary-box p {
    margin: 15px 0;
    font-size: 18px;
}
.edit-profile-button:hover {
    background-color: #0056b3;
}
.edit-profile-button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: fit-content;
    font-size: larger;
    font-weight: 1000;
    padding-left: 50px;
    padding-right: 50px;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 600px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}
.edit-questionnaire-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.edit-questionnaire-modal {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
}

.button-group {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
}

.edit-questionnaire-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 2rem;
    backdrop-filter: blur(5px);
}

.edit-questionnaire-modal {
    position: relative;
    background: linear-gradient(to right, #ffffff, #f8f9fa);
    border-radius: 15px;
    padding: 0rem;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    animation: modalFadeIn 0.4s ease-out;
}
.cancel-btn {
    background: linear-gradient(135deg, #dc3545, #c82333) !important;
    color: white !important;
    border: 0 !important;
   
}
.edit-questionnaire-modal form {
    padding: 2rem;
}

.edit-questionnaire-modal h2 {
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: 600;
    background: #3498db;
    padding: 1rem;
    
}

.button-group {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
}

.button-group button {
    flex: 1 1;
    padding: 0.8rem 1.5rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.button-group button[type="submit"] {
    background: linear-gradient(135deg, #3498db, #2980b9);
    color: white;
    border: none;
}

.button-group button[type="submit"]:hover {
    background: linear-gradient(135deg, #2980b9, #2c3e50);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(41, 128, 185, 0.3);
}

.button-group button[type="button"] {
    background: white;
    color: #2c3e50;
    border: 2px solid #e0e0e0;
}

.button-group button[type="button"]:hover {
    background: #f8f9fa;
    border-color: #3498db;
}.logout-button {
    padding: 12px 4px;
    background: linear-gradient(135deg, #e74c3c, #c0392b);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-left: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.logout-button:hover {
    background: linear-gradient(135deg, #c0392b, #962d22);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(231, 76, 60, 0.2);
}

.logout-button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);
}

/* Documents Upload Block css  */

.documents-main-heading {
    text-align: center;
    margin-bottom: 30px;
    font-family: Noto Serif Georgian;
    font-size: 50px;
    font-weight: 1000; 
    color: rgb(46, 119, 176);
    text-align: center;
    line-height: 1.5;
    border-radius: 0px;
    opacity: 1;
}

.documents-summary-box {
    /* width: 1500px !important; */
    height: 400px;
    border-radius: 15px;
    border: 6px solid  #007bff;
    padding: 20px;
    margin: 20px auto;
    background: linear-gradient(to right, #ffffff, #f8f9fa);
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.documents-summary-box h3 {
    text-align: center;
    margin-bottom: 30px;
    color: #2c3e50;
    font-size: 1.75rem;
}

.documents-details {
    padding: 40px;
    text-align: center;
}

.documents-details p {
    margin: 15px 0;
    font-size: 20px;
    line-height: 1.6;
    color: #34495e;
}

.upload-documents-button {
    padding: 15px 30px;
    background: linear-gradient(135deg, #0056b3, #0056b3);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    /* margin-left: 600px; */
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(76, 175, 80, 0.2);
}

.upload-documents-button:hover {
    background: linear-gradient(135deg, #1e12c5, #121758);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(16, 80, 218, 0.3);
}


/* Checklist css */

.checklist-main-heading {
    text-align: center;
    margin-bottom: 30px;
    font-family: Noto Serif Georgian;
    font-size: 50px;
    font-weight: 1000;
    color: rgb(46, 119, 176);
    line-height: 1.5;
}

.checklist-summary-box {
    /* width: 1500px !important; */
    height: 400px;
    border-radius: 15px;
    border: 6px solid #007bff;
    padding: 20px;
    margin: 20px auto;
    background: linear-gradient(to right, #ffffff, #f8f9fa);
    box-shadow: 0 8px 16px rgba(0, 123, 255, 0.1);
}

.checklist-summary-box h3 {
    text-align: center;
    margin-bottom: 30px;
    color: #2c3e50;
    font-size: 1.75rem;
}

.checklist-details {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px 40px;
}

.checklist-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;
}

.checklist-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.1);
    border-color: #007bff;
}

.checklist-item span {
    font-size: 16px;
    color: #2c3e50;
    font-weight: 500;
}

.check-icon {
    font-size: 24px;
    color: #d37b7b;
    transition: all 0.3s ease;
}

.checklist-item:hover .check-icon {
    transform: scale(1.2);
}

.questionnaire-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* gap: 20px; */
    padding: 10px;
}

.detail-item {
    display: flex;
    align-items: center;
    /* gap: 15px; */
    width: 100%;
    max-width: 600px;
}

.detail-label {
    font-weight: 500;
    color: #2c3e50;
    min-width: 210px;
    text-align: right;
}

.detail-value {
    color: #646464;
    font-size: 16px;
    padding: 8px 16px;
    /* background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1); */
    flex-grow: 1;
    text-align: left;
}
.document-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

.document-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 80%;
    max-height: 80%;
    overflow: auto;
    position: relative;
}

.close {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 24px;
    cursor: pointer;
}

.checklist-item {
    cursor: pointer;
}

.fa-times-circle {
    color: #dc3545;
}
.fa-check-circle {
    /* color: #28a745; */
}.document-modal-content {
    width: 90%;
    height: 90vh;
    background: white;
    padding: 20px;
    position: relative;
}

.document-modal-content iframe {
    background: white;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
/* Modern Dashboard Styling */
.dashboard-container {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    min-height: 100vh;
}

.main-heading, .profile-main-heading, .documents-main-heading, .checklist-main-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    color: #1a73e8;
    margin: 40px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    position: relative;
}

.main-heading::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(90deg, #1a73e8, #34a853);
    border-radius: 2px;
}

.questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {
    background: white;
    border: none;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    margin: 30px auto;
    padding: 30px;
    text-align:center;
}

.questionnaire-summary-box:hover, .profile-summary-box:hover {
    /* transform: translateY(-5px); */
}

.edit-questionnaire-button, .edit-profile-button, .upload-documents-button, .recommendations-button {
    background: linear-gradient(135deg, #1a73e8, #4285f4);
    color: white;
    padding: 12px 30px;
    border-radius: 25px;
    font-weight: 400;
    border: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(26, 115, 232, 0.2);
    margin-top: 40px;
    font-size: 14px;
    text-transform: uppercase;
}

.edit-questionnaire-button:hover, .edit-profile-button:hover {
    background: linear-gradient(135deg, #4285f4, #1a73e8);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(26, 115, 232, 0.3);
}

.profile-details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0px;
    padding: 20px;
}

.profile-details p {
    /* background: #f8f9fa; */
    padding: 15px;
    /* border-radius: 10px; */
    margin: 0;
    transition: all 0.3s ease;
    border: 1px solid #e8e8e8;
}

.profile-details p:hover {
    /* background: #e9ecef; */
    /* transform: translateX(5px); */
}

/* Sidebar styling */
.sidebar {
    width: 250px;
    background: #2c3e50;
    color: #ecf0f1;
    /* height: 100vh; */
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
      position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  flex-shrink: 0;
  z-index: 10;
}

.sidebar .logo {
    text-align: center;
    padding: 20px;
    background: #111827;
    font-size: 1.5rem;
    font-weight: bold;
}

.sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar ul li {
    font-size: 12px;
    padding: 14px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: background 0.3s ease;
    border-bottom: 1px solid #5a5a5a;
}

.sidebar ul li:hover {
    background: #34495e;
}

.sidebar ul li i {
    font-size: 1.2rem;
}

.sidebar ul li.active {
    background: #1a73e8;
}

/* Main content */
.content {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
}

.tab-content {
    display: none;
}

.tab-content.active {
    display: block;
}

.tab-content h2 {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 10px;
}

.tab-content p {
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
}

.dashboard-container {
    display: flex;
}
.authenticated-main {
    padding: 0px !important;
    margin-top: 70px !important;
}

.tab-content h2 {
    padding: 15px;
    background: #2596be;
    color: #ffffff;
    font-size: 18px;
}

.questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {
    background: transparent !important;
    box-shadow: unset !important;
}
.content {
    background-color: #ffffff;
    padding: 0 !important;
}
.detail-item {
    border: 1px solid #e8e8e8;
}
.detail-label, .detail-value {
    /* border: 1px solid #e8e8e8; */
    line-height: 21px;
    font-size: 14px;
    padding: 15px;
}
.detail-label {
    text-align: left;
}

.profile-details p span {
    display: inline-block;
    width: 50%;
    text-align: left;
}

@media (max-width: 768px) {
    
    .sidebar ul li span, .sidebar .logo {
        display: none;
    }
    .sidebar {
        width: auto;
    }
    
    .questionnaire-summary-box, .documents-summary-box, .checklist-summary-box {
        height: auto !important;
        padding: 16px !important;
    }
    .questionnaire-summary-box h3, .documents-summary-box h3, .tab-content h2,
    .profile-summary-box h3, .checklist-summary-box h3 {
        font-size: 16px !important;
    }
    .detail-label {
        min-width: auto !important;
        text-align: left !important;
    }
    .detail-value {
        text-align: right !important;
    }
    .edit-questionnaire-button, .edit-profile-button, .upload-documents-button, .recommendations-button {

        padding: 10px 15px !important;
        font-weight: 500 !important;
        font-size: 16px !important;
    }
    .checklist-details {
        grid-template-columns: unset !important;
    }
    .profile-details p strong {
        min-width: auto !important;
    }
    .profile-details {
        padding: 0 !important;
        display: block !important;
    }
    .profile-summary-box, .profile-details {
        height: auto !important;
        max-height: unset !important;
    }
    .questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {
        padding: 30px 15px !important;
    }
    .checklist-details {
        padding: 20px 15px !important;
    }
    
    .tab-content h2 {
        padding: 15px;
        background: #2596be;
        color: #ffffff;
    }
    
    
    .profile-details p span:nth-child(odd) {
        text-align: left;
    }
    
    .profile-details p span:nth-child(even) {
        text-align: right;
    }
    .chatbot-container {
        max-width: 300px !important;
    }
    .message {
        max-width: 80% !important;
    }
}

/* Main container for the chatbot */
.chatbot-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    max-width: 400px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    width: 350px;
    resize: both;
    overflow: auto;
  }
  .recommendation-button, .chatbot-footer button {
    background-color: transparent; 
    border: 2px solid #1a73e8;
    color: #1a73e8;
  }
  .recommendation-button:hover {
    background-color: #1a73e8 !important;
    color: #ffffff !important;
  }
  /* Header section */
  .chatbot-header {
    background-color: #1a73e8; /* Your theme color */
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    position: relative;
  }
  
  /* Logo position and styling */
  .chatbot-header img {
    width: 40px; /* Adjust the logo size */
    height: auto;
    margin-right: 10px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  /* Close button on header */
  .chatbot-header button {
    background: transparent;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  /* Body section */
  .chatbot-body {
    padding: 10px;
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  
  /* Message bubbles */
  .message {
    max-width: 70%;
    padding: 10px 15px;
    border-radius: 20px;
    margin: 5px 0;
    word-wrap: break-word;
  }
  
  .message.user {
    background-color: #1a73e8;
    align-self: flex-end;
    border-radius: 20px 20px 0 20px;
  }
  
  .message.bot {
    background-color: #f1f1f1;
    align-self: flex-start;
    border-radius: 20px 20px 20px 0;
  }
  
  /* FAQ suggestions container */
  .chatbot-faqs {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }
  
  .faq-button {
    background-color: #2596be; /* Your theme color */
    color: white;
    border: none;
    padding: 10px 15px;
    margin: 5px 0;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    width: 100%; /* Take full width to make it blend into the chat */
  }
  
  .faq-button:hover {
    background-color: #1f82a1; /* Darker shade for hover effect */
  }
  
  /* Footer with input */
  .chatbot-footer {
    display: flex;
    padding: 10px;
    background: #f9f9f9;
    border-top: 1px solid #e0e0e0;
  }
  
  .chatbot-footer input {
    flex-grow: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 20px;
    margin-right: 10px;
    font-size: 14px;
  }
  
  .chatbot-footer button {
    background-color: #1a73e8;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    
    width: 44px !important;
    height: 44px !important;
  }
  
  .chatbot-footer button:hover {
    background-color: #1f82a1;
  }
  
  /* Make chat icon smaller and more centered */
  .chat-icon {
    position: fixed;
    bottom: 30px;
    right: 30px;
    background-color: #1a73e8;
    border-radius: 50%;
    padding: 15px;
    color: white;
    font-size: 22px;
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
  
  .chat-icon:hover {
    background-color: #1f82a1;
  }
  
  /* Typing animation for bot */
  .chatbot-typing-logo {
    width: 30px;
    height: auto;
    animation: typing 1.5s infinite ease-in-out;
    margin-right: 10px;
  }
  
  /* Animation for typing effect */
  @keyframes typing {
    0% { opacity: 0.5; }
    50% { opacity: 1; }
    100% { opacity: 0.5; }
  }
  /* ===== CSS VARIABLES FROM SINGLEPOSTPAGE DESIGN ===== */
:root {
  /* 🔵 Core Theme Colors */
  --primary-color: #1E3A8A;             /* Deep Blue */
  --secondary-color: #3B82F6;           /* Bright Blue */
  --accent-color: #60A5FA;              /* Light Blue Accent */
  --danger-color: #ea4335;

  /* 🌑 Dark Mode Backgrounds */
  --dark-bg: #0f1419;
  --dark-card: #111827;
  --dark-surface: #1f2937;

  /* 🖋️ Text Colors */
  --text-primary: #ffffff;
  --text-secondary: #cbd5e1;
  --text-muted: #8a9ba8;

  /* 🧱 Border */
  --border-color: #374151;

  /* 🎨 Gradients */
  --gradient-primary: linear-gradient(135deg, #1E3A8A 0%, #3B82F6 50%, #60A5FA 100%);
  --gradient-secondary: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  --gradient-dark: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 100%);

  /* 🕶️ Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.6);

  /* 🟦 Border Radius */
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  /* 📐 Spacing Scale */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;
  --spacing-3xl: 64px;

  /* 🕒 Transitions */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
}

  
  /* ===== GLOBAL STYLES ===== */
  * {
    box-sizing: border-box;
  }
  
  body {
    
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;


    background: var(--dark-bg);
    color: var(--text-primary);
    margin: 0;
    padding: 0;
    line-height: 1.6;
  }
  
/* ===== DASHBOARD CONTAINER ===== */
.dashboard-container {
  display: flex;
  min-height: 100vh;
  background: var(--dark-bg);
  position: relative;
  font-family: 'Poppins', sans-serif !important;


 background-image: 
    radial-gradient(circle at top left, rgba(255,255,255,0.015), transparent),
    radial-gradient(circle at bottom right, rgba(59,130,246,0.05), transparent);
  backdrop-filter: blur(1.5px);
  transition: background 0.5s ease;
  font-family: 'Poppins', sans-serif !important;
}

  
  /* ===== SIDEBAR DESIGN ===== */
.sidebar {
  width: 280px;
  background: linear-gradient(to bottom, #111827 0%, #1f2937 100%) !important; /* Clean dark vertical blend */
  border-right: 1px solid var(--border-color) !important;
  box-shadow: var(--shadow-lg) !important;
  
  position: fixed !important;
  height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 1000 !important;
  
  overflow-y: auto !important;
  transition: all var(--transition-normal) !important;
  
  backdrop-filter: blur(8px) !important; /* Softens hard dark edges */
}
.sidebar-header {
  padding: var(--spacing-xl);
  border-bottom: 1px solid var(--border-color);
  background: var(--dark-card);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.04); /* added subtle depth */
}

.sidebar-header h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4); /* better legibility on gradient */
}

.sidebar ul {
  list-style: none;
  padding: var(--spacing-lg) 0;
  margin: 0;
}

.sidebar ul li {
  margin: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  transition: all var(--transition-normal);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.015); /* gentle card lift */
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02); /* soft edge */
  will-change: transform, color;
}

.sidebar ul li::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: var(--gradient-primary);
  transition: all var(--transition-normal);
  z-index: -1;
  filter: brightness(1.05) saturate(1.1);
  opacity: 0.9;
}

.sidebar ul li:hover::before,
.sidebar ul li.active::before {
  left: 0;
}

.sidebar ul li span {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all var(--transition-normal);
  position: relative;
  z-index: 1;
}

.sidebar ul li:hover span,
.sidebar ul li.active span {
  color: var(--text-primary);
  transform: translateX(4px);
  font-weight: 600;
  letter-spacing: 0.3px;
}

.sidebar ul li i {
  font-size: 1.2rem;
  width: 24px;
  text-align: center;
  transition: all var(--transition-normal);
}

.sidebar ul li:hover i,
.sidebar ul li.active i {
  transform: scale(1.1);
  color: var(--text-primary);
}

.sidebar ul li.active {
  border: 1px solid rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.3); /* glowing active item */
}

  /* ===== MAIN CONTENT AREA ===== */
  .content {
    margin-left: 280px;
    flex: 1 1;
    background: var(--dark-bg);
    min-height: 100vh;
    padding: var(--spacing-2xl);
  }
  
  /* ===== TAB CONTENT ===== */
  .tab-content {
    display: none;
    animation: fadeInUp 0.6s ease-out;
  }
  
  .tab-content.active {
    display: block;
  }
  
  .tab-content h2 {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: var(--spacing-2xl);
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    /* -webkit-text-fill-color: transparent; */
    background-clip: text;
    text-align: center;
    position: relative;
  }
  
  .tab-content h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: var(--gradient-primary);
    border-radius: 2px;
  }
  
  /* ===== DASHBOARD CARDS ===== */
 .dashboard-card {
  background: linear-gradient(145deg, #111827, #1a1f2e); /* dark blend */
  color: var(--text-primary);
  border-radius: var(--radius-lg);
  border: 1px solid rgba(59, 130, 246, 0.1);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.05);
  padding: var(--spacing-2xl);
  backdrop-filter: blur(2px);
  transition: background 0.4s ease;

  /* Optional visual texture */
  background-image: radial-gradient(circle at top left, rgba(59,130,246,0.04), transparent),
                    radial-gradient(circle at bottom right, rgba(59,130,246,0.06), transparent);
}

  
  .dashboard-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--gradient-primary);
  }
  
  .dashboard-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-xl);
    border-color: var(--primary-color);
  }
  
  .dashboard-card h3 {
    color: var(--text-primary);
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: var(--spacing-lg);
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
  }
  
  .dashboard-card h3 i {
    color: var(--primary-color);
    font-size: 1.3rem;
  }
  
  .dashboard-card p {
    color: var(--text-secondary);
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: var(--spacing-lg);
  }
  
  /* ===== QUESTIONNAIRE SUMMARY ===== */
.questionnaire-summary-box {
  background: var(--dark-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-2xl);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); /* slightly softer depth */
  position: relative;
  overflow: hidden;
  margin-bottom: var(--spacing-xl);
  background-image: 
    linear-gradient(135deg, rgba(26, 115, 232, 0.06), rgba(17, 24, 39, 0.9)),
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.015), transparent),
    radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.03), transparent);
  backdrop-filter: blur(2px);
  transition: all 0.4s ease;
}

  
  .questionnaire-summary-box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--gradient-primary);
  }
  
  .questionnaire-summary-box h3 {
    color: var(--text-primary);
    font-size: 1.75rem;
    font-weight: 600;
    margin-bottom: var(--spacing-xl);
    text-align: center;
  }
  
  .questionnaire-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: var(--spacing-lg);
    margin-bottom: var(--spacing-xl);
  }
  
  .detail-item {
    background: var(--dark-surface);
    padding: var(--spacing-lg);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    border-left: 4px solid var(--primary-color);
    transition: all var(--transition-normal);
    position: relative;
    overflow: hidden;
  }
  
  .detail-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(26, 115, 232, 0.1), transparent);
    transition: all var(--transition-slow);
  }
  
  .detail-item:hover::before {
    left: 100%;
  }
  
  .detail-item:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
    border-left-color: var(--secondary-color);
  }
  
  .detail-label {
    display: block;
    font-weight: 600;
    color: var(--text-muted);
    font-size: 0.85rem;
    margin-bottom: var(--spacing-sm);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .detail-value {
    display: block;
    font-weight: 500;
    color: var(--text-primary);
    font-size: 1.1rem;
  }
  
  /* ===== BUTTONS ===== */
  .edit-questionnaire-button,
  .edit-profile-button {
    background: var(--gradient-primary);
    color: var(--text-primary);
    border: none;
    padding: var(--spacing-md) var(--spacing-xl);
    border-radius: var(--radius-md);
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-md);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm);
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }
  
  .edit-questionnaire-button::before,
  .edit-profile-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: all var(--transition-slow);
  }
  
  .edit-questionnaire-button:hover::before,
  .edit-profile-button:hover::before {
    left: 100%;
  }
  
  .edit-questionnaire-button:hover,
  .edit-profile-button:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
  }





  
.profile-summary-box {
  background-color: #111827 !important; /* lighter than #1a1f2e */
  border-radius: var(--radius-lg);
  padding: var(--spacing-2xl);
  border: 1px solid var(--primary-color);
  box-shadow: 0 0 10px rgba(26, 115, 232, 0.1);
  position: relative;
  overflow: hidden;

  background-image: radial-gradient(
    circle at top left,
    rgba(255, 255, 255, 0.04),
    transparent
  ), radial-gradient(
    circle at bottom right,
    rgba(59, 130, 246, 0.08),
    transparent
  );
  backdrop-filter: blur(2px);
  transition: background 0.4s ease;
}


  
  .profile-summary-box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--gradient-primary);
  }
  
  .profile-summary-box h3 {
    color: var(--text-primary);
    font-size: 1.75rem;
    font-weight: 600;
    margin-bottom: var(--spacing-xl);
    text-align: center;
  }
  
  .profile-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-xl);
  }
  
  .profile-details p {
    display: flex;
    align-items: center;
    background: var(--dark-surface);
    padding: var(--spacing-lg);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    margin-bottom: 0;
    border-left: 4px solid var(--secondary-color);
    transition: all var(--transition-normal);
    position: relative;
    overflow: hidden;
  }
  
  .profile-details p::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(52, 168, 83, 0.1), transparent);
    transition: all var(--transition-slow);
  }
  
  .profile-details p:hover::before {
    left: 100%;
  }
  
  .profile-details p:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
  
  .profile-details p span:first-child {
    font-weight: 600;
    color: var(--text-muted);
    min-width: 140px;
    font-size: 0.9rem;
  }
  .profile-details p span:last-child {
    color: var(--text-primary);
    font-weight: 500;
    font-size: 1rem;
    margin-left: var(--spacing-md);
  }
  
  /* ===== FEATURE ITEMS ===== */
  .feature-item {
    text-align: center;
    padding: var(--spacing-2xl);
    background: var(--dark-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
    border: 1px solid var(--border-color);
    transition: all var(--transition-normal);
    position: relative;
    overflow: hidden;
  }
  
  .feature-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--gradient-primary);
  }
  
  .feature-item:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-xl);
    border-color: var(--primary-color);
  }
  
  .feature-item i {
    font-size: 3rem;
    margin-bottom: var(--spacing-lg);
    display: block;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .feature-item h4 {
    margin: var(--spacing-lg) 0 var(--spacing-md) 0;
    color: var(--text-primary);
    font-size: 1.25rem;
    font-weight: 600;
  }
  
  .feature-item p {
    margin: 0;
    color: var(--text-secondary);
    font-size: 1rem;
    line-height: 1.5;
  }
  
  /* ===== PAYMENT SUCCESS ===== */
  .payment-success {
    text-align: center;
    padding: var(--spacing-2xl);
  }
  
  .payment-success h3 {
    color: var(--secondary-color);
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: var(--spacing-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-md);
  }
  
  .payment-success h3::before {
    content: '✅';
    font-size: 2.5rem;
  }
  
  .payment-success p {
    color: var(--text-secondary);
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: var(--spacing-xl);
  }
  
  /* ===== BLUR CONTENT ===== */
  .blur-content {
    filter: blur(4px);
    pointer-events: none;
    position: relative;
  }
  
  .blur-content::after {
  content: '🔒 Complete Payment to Unlock';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(
    135deg,
    rgba(26, 115, 232, 0.08),
    rgba(17, 24, 39, 0.95)
  );
  background-image: radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.02),
      transparent
    ),
    radial-gradient(
      circle at bottom right,
      rgba(59, 130, 246, 0.06),
      transparent
    );
  color: var(--text-primary);
  padding: var(--spacing-lg) var(--spacing-xl);
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 1.1rem;
  box-shadow: var(--shadow-lg);
  border: 2px solid var(--primary-color);
  z-index: 10;
  pointer-events: all;
  text-align: center;
  backdrop-filter: blur(4px);
  transition: background 0.4s ease;
}

  
  /* ===== NOTE STYLES ===== */
  .note {
    background: rgba(251, 188, 4, 0.1);
    border: 2px solid var(--accent-color);
    border-radius: var(--radius-md);
    padding: var(--spacing-lg);
    margin-bottom: var(--spacing-xl);
    color: var(--accent-color);
    font-weight: 500;
    text-align: center;
    font-size: 1rem;
    position: relative;
  }
  
  .note::before {
    content: '⚠️';
    margin-right: var(--spacing-sm);
    font-size: 1.2rem;
  }
/* 














































*/
  
  /* ===== ANIMATIONS ===== */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .animate-fade-in-up {
    animation: fadeInUp 0.6s ease-out;
  }
  
  /* ===== MOBILE RESPONSIVENESS ===== */
  @media (max-width: 1024px) {
    .sidebar {
      width: 260px;
    }
    
    .content {
      margin-left: 260px;
      padding: var(--spacing-xl);
    }
    
    .tab-content h2 {
      font-size: 2.25rem;
    }
  }
  
  @media (max-width: 768px) {
    .sidebar {
      width: 100%;
      height: auto;
      position: relative;
      box-shadow: none;
      border-right: none;
      border-bottom: 1px solid var(--border-color);
    }
    
    .sidebar ul {
      display: flex;
      overflow-x: auto;
      padding: var(--spacing-md);
      gap: var(--spacing-sm);
    }
    
    .sidebar ul li {
      margin: 0;
      min-width: 120px;
      flex-shrink: 0;
    }
    
    .sidebar ul li span {
      flex-direction: column;
      text-align: center;
      padding: var(--spacing-md);
      font-size: 0.8rem;
      gap: var(--spacing-xs);
    }
    
    .sidebar ul li i {
      font-size: 1.5rem;
    }
    
    .content {
      margin-left: 0;
      padding: var(--spacing-lg);
    }
    
    .tab-content h2 {
      font-size: 1.75rem;
      margin-bottom: var(--spacing-xl);
    }
    
    .dashboard-card,
    .questionnaire-summary-box,
    .profile-summary-box {
      padding: var(--spacing-sm);
    }
    
    .questionnaire-details,
    .profile-details {
      grid-template-columns: 1fr;
      gap: var(--spacing-md);
    }
    
    .detail-item,
    .profile-details p {
      padding: var(--spacing-md);
    }
    
    .profile-details p {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--spacing-xs);
    }
    
    .profile-details p span:first-child {
      min-width: auto;
      font-size: 0.8rem;
    }
    
    .profile-details p span:last-child {
      margin-left: 0;
      font-size: 0.95rem;
    }
  }
  
  @media (max-width: 480px) {
    .content {
      padding: var(--spacing-md);
    }
    
    .tab-content h2 {
      font-size: 1.5rem;
    }
    
    .dashboard-card,
    .questionnaire-summary-box,
    .profile-summary-box {
      padding: var(--spacing-lg);
    }
    
    .dashboard-card h3,
    .questionnaire-summary-box h3,
    .profile-summary-box h3 {
      font-size: 1.25rem;
    }
    
    .feature-item {
      padding: var(--spacing-lg);
    }
    
    .feature-item i {
      font-size: 2.5rem;
    }
    
    .feature-item h4 {
      font-size: 1.1rem;
    }
    
    .edit-questionnaire-button,
    .edit-profile-button {
      padding: var(--spacing-md) var(--spacing-lg);
      font-size: 0.9rem;
    }
    
    .payment-success h3 {
      font-size: 1.5rem;
      flex-direction: column;
      gap: var(--spacing-sm);
    }
    
    .blur-content::after {
      font-size: 0.9rem;
      padding: var(--spacing-md) var(--spacing-lg);
    }
  }
  
  /* ===== SCROLLBAR STYLING ===== */
  .sidebar::-webkit-scrollbar {
    width: 6px;
  }
  
  .sidebar::-webkit-scrollbar-track {
    background: var(--dark-surface);
  }
  
  .sidebar::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
  }
  
  .sidebar::-webkit-scrollbar-thumb:hover {
    background: var(--primary-color);
  }
  
  /* ===== LOADING STATES ===== */
  .loading-spinner-small {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid var(--text-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: var(--spacing-sm);
  }
  
  /* ===== HOVER EFFECTS ===== */
  .dashboard-card:hover h3 i {
    transform: scale(1.2) rotate(5deg);
    transition: all var(--transition-normal);
  }
  
  .feature-item:hover i {
    transform: scale(1.1) rotate(-5deg);
    transition: all var(--transition-normal);
  }
  
  /* ===== FOCUS STATES ===== */
  .edit-questionnaire-button:focus,
  .edit-profile-button:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
  
  /* ===== HIGH CONTRAST MODE ===== */
  @media (prefers-contrast: high) {
    :root {
      --border-color: #ffffff;
      --text-secondary: #ffffff;
      --text-muted: #cccccc;
    }
  }
  
  /* ===== REDUCED MOTION ===== */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
  /* Add these viewport handling rules to your existing CSS */

/* ===== MOBILE RESPONSIVENESS - VIEWPORT HANDLING ONLY ===== */
@media (max-width: 768px) {
    .content {
      margin-left: 0;
      width: 100%;
      min-width: 0;
      overflow-x: hidden;
    }
    
    .sidebar {
      display: none;
    }
  }
  
  @media (max-width: 480px) {
    .content {
      padding: var(--spacing-md);
      min-height: 100vh;
    }
    
    .questionnaire-details {
      grid-template-columns: 1fr;
    }
    
    .profile-details {
      grid-template-columns: 1fr;
    }
  }
  
  /* ===== ENSURE CONTENT IS ALWAYS VISIBLE ===== */
  .dashboard-container {
    min-height: 100vh;
    overflow-x: hidden;
  }
  
  .content {
    min-height: 100vh;
    position: relative;
    z-index: 1;
  }

  @media (max-width: 768px) {
    .dashboard-container {
      flex-direction: column;
    }
    
    .sidebar {
      width: 100%;
      height: auto;
      position: static;
      border-right: none;
      border-bottom: 2px solid var(--border-color);
    }
    
    .sidebar ul {
      display: flex;
      overflow-x: scroll;
      padding: 10px;
      margin: 0;
    }
    
    .sidebar ul li {
      flex: none;
      margin: 0 5px;
      padding: 10px 15px;
      min-width: 80px;
      text-align: center;
    }
    
    .sidebar ul li span {
      display: block;
      font-size: 12px;
    }
    
    .content {
      margin-left: 0;
    }
  }
  
  
  .dashboard-feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--spacing-lg);
    margin-top: var(--spacing-xl);
  }
  
  .profile-details-subtitle {
    text-align: center;
    color: var(--text-secondary);
    margin-bottom: var(--spacing-xl);
  }
  
  .questionnaire-summary-subtitle {
    text-align: center;
    color: var(--text-secondary);
    margin-bottom: var(--spacing-xl);
  }


  /* ============================================================
   Recommendations.css
   University Recommendations Panel Styling
   ============================================================ */

/* —— Color Variables —— */
:root {
  --primary: #377DFF;
  --primary-dark: #265EDC;
  --bg-page: #11151f;
  --bg-panel: #1a1f2e;
  --bg-card: #242837;
  --bg-input: #1a1f2e;
  --border: #3a3f57;
  --text: #e0e2e7;
  --text-muted: #999;
}

/* ============================================================
   Filters Container
   ============================================================ */
.recommendations-filters {
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

/* —— Field-of-Study Pills —— */
.filter-pills {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pill {
  background: var(--bg-input);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.4rem 0.8rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}
.pill.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

/* —— Numeric & Text Inputs —— */
.filter-inputs {
  flex: 1 1 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
}
.filter-item {
  display: flex;
  flex-direction: column;
  font-size: 0.85rem;
  color: var(--text);
}
.filter-item label {
  margin-bottom: 0.2rem;
}
.filter-item input {
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 0.4rem 0.6rem;
  color: #fff;
  transition: border-color 0.2s;
}
.filter-item input::placeholder {
  color: var(--text-muted);
}
.filter-item input:focus {
  outline: none;
  border-color: var(--primary);
}

/* —— Search Button —— */
.search-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  align-self: flex-end;
  flex: 0 0 auto;
}
.search-btn:hover {
  background: var(--primary-dark);
}
/* push search to right on desktop */
.recommendations-filters > .search-btn {
  margin-left: auto;
}

/* ============================================================
   Loading Bar
   ============================================================ */
.loading-bar {
  position: relative;
  height: 4px;
  background: var(--border);
  border-radius: 2px;
  overflow: hidden;
  margin: 1rem 0;
}
.loading-bar-progress {
  position: absolute;
  height: 100%;
  width: 0;
  background: var(--primary);
  animation: loading 1s infinite;
}
@keyframes loading {
  0%   { width: 0;   }
  50%  { width: 80%; }
  100% { width: 0;   }
}

/* ============================================================
   University Cards Grid
   ============================================================ */
.universities-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
}
.university-card {
  background: var(--bg-card);
  color: var(--text);
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  transition: transform 0.2s, border-color 0.2s;
  
}
.university-card:hover {
  transform: translateY(-4px);
  border-color: var(--primary);
}
.university-card h4 {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
}
.university-card .location {
  font-size: 0.9rem;
  color: var(--text-muted);
  margin-bottom: 0.8rem;
}
.university-card p {
  margin: 0.3rem 0;
  font-size: 0.9rem;
}

/* —— Card Buttons —— */
.card-buttons {
  margin-top: auto;
  display: flex;
  gap: 0.5rem;
}
.budget-btn,
.apply-btn {
  flex: 1 1;
  padding: 0.5rem;
  font-size: 0.9rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.budget-btn {
  background: var(--bg-input);
  color: var(--text);
}
.budget-btn:hover {
  background: var(--border);
}
.apply-btn {
  background: var(--primary);
  color: #fff;
}
.apply-btn:hover {
  background: var(--primary-dark);
}

/* ============================================================
   Budget Modal
   ============================================================ */
.budget-modal-backdrop {
  /* cover the viewport */
  position: fixed;
  inset: 0;                        /* shorthand for top/right/bottom/left: 0 */
  background: rgba(0,0,0,0.6);
  
  /* center its child */
  display: flex;
  align-items: center;
  justify-content: center;

  /* ensure it’s above everything else */
  z-index: 1000;

  /* allow scrolling inside on very small viewports */
  padding: 20px;
}

.budget-modal {
  /* remove any fixed/absolute positioning */
  position: relative;

  /* size & look */
  background: var(--bg-panel);
  padding: 2rem;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;               /* or your desired width */
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.5);

  /* make sure it never overflows the viewport */
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

/* your close button etc. can stay exactly as before */
.modal-close-btn {
  position: absolute;
  top: 0.5rem; right: 0.5rem;
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
}
.modal-close-btn:hover {
  color: #fff;
}
.budget-modal h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}
.budget-modal p {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: var(--text);
}
.budget-modal hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 1rem 0;
}

/* —— No Matches Found —— */
.no-results {
  color: var(--text-muted);
  font-style: italic;
  margin-top: 1rem;
}

/* ============================================================
   Responsive Breakpoints
   ============================================================ */
@media (max-width: 900px) {
  .recommendations-filters {
    gap: 0.75rem;
  }
  .filter-inputs {
    grid-template-columns: repeat(auto-fill, minmax(120px,1fr));
  }
}

@media (max-width: 600px) {
  .recommendations-filters {
    flex-direction: column;
    gap: 0.75rem;
  }
  .filter-inputs {
    grid-template-columns: 1fr;
  }
  .search-btn {
    width: 100%;
    margin: 0;
  }
  .universities-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .pill {
    font-size: 0.85rem;
    padding: 0.35rem 0.7rem;
  }
}
.invalid-input {
  border: 1px solid #ff5b5b;
  background-color: #2e1e1e;
}
.error-text {
  color: #ff5b5b;
  font-size: 0.75rem;
  margin-top: 4px;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  background: #121827;
  z-index: 1000;
}




.universities-list {
  display: flex !important;
  overflow-x: auto !important;
  gap: 1rem !important;
  padding-bottom: 1rem !important;
  scroll-snap-type: x mandatory !important;
  -webkit-overflow-scrolling: touch !important;
}

.universities-list::-webkit-scrollbar {
  height: 6px !important;
}

.universities-list::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.5) !important;
  border-radius: 3px !important;
}

.university-card {
  flex: 0 0 240px !important;
  scroll-snap-align: start !important;
}


@media (max-width: 600px) {
  .universities-list {
    display: grid !important;
    grid-template-columns: 1fr !important;
    overflow-x: hidden !important;
  }

  .university-card {
    flex: 1 1 100% !important;
    scroll-snap-align: none !important;
  }
}

.premium-advisor {
  padding: 20px;
  background: #1c1e2a;
  border-radius: 10px;
  color: white;
}

.mode-selector button,
.premium-advisor button {
  margin: 10px;
  padding: 10px 20px;
  background: #34a853;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.upload-section input,
.form-section input,
.form-section textarea {
  display: block;
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border-radius: 5px;
}

.result-box {
  margin-top: 20px;
}
.premium-advisor {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #1a1f2e;
}
input, textarea {
  width: 100%;
  padding: 10px;
  margin: 0.5rem 0;
}
button {
  padding: 10px 20px;
  margin: 10px 5px;
}
.result-box, .error {
  margin-top: 20px;
}
/* ─── Themed Hot-Offer Box ─────────────────────────────────────────── */
.hot-offer-box {
  background: #161b22;                   /* match your card bg */
  border: 1px solid #30363d;             /* match your border color */
  border-left: 4px solid #238636;        /* green accent, or pick your brand blue #58a6ff */
  border-radius: 6px;
  padding: 16px;
  margin: 20px 0;
  color: #c9d1d9;
  box-shadow: 0 2px 4px rgba(0,0,0,0.4);
}
.hot-offer-box h3 {
  margin: 0 0 8px;
  color: #58a6ff;                         /* your primary accent */
}
.hot-offer-box p {
  margin: 4px 0;
  color: #8b949e;                         /* muted text */
}

/* ─── Payment Card Tweaks ─────────────────────────────────────────── */
.payment-card {
  border: 1px solid #30363d;
  background: #161b22;
  color: #c9d1d9;
}
.payment-card h3 {
  color: #58a6ff;
}
.paid-card {
  text-align: center;
}
.paid-card i.fa-check-circle {
  color: #238636;                        /* success green */
  font-size: 1.5em;
  vertical-align: middle;
  margin-right: 8px;
}
.paid-card p {
  margin: 12px 0;
}

/* ─── “View Recommendations” button ───────────────────────────────── */
.go-to-recs {
  background: #58a6ff;
  border: none;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95em;
}
.go-to-recs:hover {
  background: #3a7bcc;
}



/* ─── Promo-Poster Card ─────────────────────────────────────────────── */

.promo-card {
  background: linear-gradient(135deg, #0d1117 0%, #161b22 100%);
  border: 2px solid #30363d;
  border-left: 6px solid #58a6ff;   /* your primary accent */
  border-radius: 8px;
  padding: 24px;
  margin: 20px 0;
  color: #c9d1d9;
  box-shadow: 0 4px 12px rgba(0,0,0,0.6);
  text-align: center;
}
.promo-header {
  font-size: 1.5em;
  color: #58a6ff;
  margin-bottom: 8px;
}
.promo-subtitle {
  font-size: 1em;
  color: #8b949e;
  margin-bottom: 16px;
  line-height: 1.4;
}
.promo-features {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  text-align: left;
  display: inline-block;
}
.promo-features li {
  display: flex;
  align-items: center;
  margin: 8px 0;
  font-size: 0.95em;
}
.promo-features li i {
  color: #238636;  /* success-green accent */
  margin-right: 10px;
  font-size: 1.1em;
}
.promo-action {
  margin-top: 12px;
}
/* If your PaymentSection renders a button, you can target it: */
.promo-action button {
  background: #58a6ff;
  border: none;
  color: #fff;
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}
.promo-action button:hover {
  background: #3a7bcc;
}






/* Container spacing */
#recommendations.tab-content {
  padding: 16px 0 24px;
}

/* Premium section */
.premium-section {
  background: #0f1523;
  border: 1px solid #2a3246;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 18px;
}
.premium-section h3 {
  margin: 0 0 6px;
}
.premium-section p {
  margin: 0 0 12px;
  color: #b9c0d4;
}

/* Normal recommendations area */
.recommendations-filters {
  background: #0b1020;
  border: 1px solid #252d41;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}
.filter-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}
.filter-pills strong {
  margin-right: 8px;
  color: #9fb0d0;
  font-weight: 600;
}
.pill {
  border: 1px solid #2b3550;
  background: #121a2f;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}
.pill.active { outline: 2px solid #2e7d32; }

.filter-inputs {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}
@media (max-width: 980px) {
  .filter-inputs { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 560px) {
  .filter-inputs { grid-template-columns: 1fr; }
}
.filter-item label {
  display: block;
  font-size: 12px;
  color: #8ea0c0;
  margin-bottom: 4px;
}
.filter-item input {
  width: 100%;
  background: #0f172a;
  border: 1px solid #29324a;
  border-radius: 8px;
  padding: 10px 12px;
  color: #e6ecff;
}
.filter-item input.invalid-input {
  border-color: #d33;
}
.error-text {
  display: block;
  margin-top: 4px;
  color: #ff9b9b;
  font-size: 12px;
}

.search-btn {
  margin-top: 12px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 0;
  background: #2563eb;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.search-btn:disabled { opacity: .5; cursor: not-allowed; }

/* Loading bar */
.loading-bar {
  height: 6px;
  border-radius: 999px;
  background: #101626;
  overflow: hidden;
  margin: 12px 0 6px;
}
.loading-bar-progress {
  width: 45%;
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #22c55e);
  animation: slide 1.2s infinite linear;
}
@keyframes slide {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(220%); }
}

/* Results grid */
.universities-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
@media (max-width: 1100px) {
  .universities-list { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 680px) {
  .universities-list { grid-template-columns: 1fr; }
}
.university-card {
  background: #0c1326;
  border: 1px solid #24304b;
  border-radius: 12px;
  padding: 14px;
}
.university-card h4 { margin: 0 0 6px; }
.university-card .location { color: #9fb0d0; margin: 0 0 8px; }
.card-buttons {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.budget-btn, .apply-btn {
  flex: 1 1;
  border: 0;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
}
.budget-btn { background: #1f2937; color: #dbeafe; }
.apply-btn  { background: #22c55e; color: #0b1220; font-weight: 700; }

/* Disabled normal UI when Premium */
.normal-disabled {
  position: relative;
  opacity: .45;
  pointer-events: none;   /* disables clicks inside */
  filter: grayscale(0.2);
}
.normal-disabled .disabled-overlay {
  pointer-events: none;
  position: absolute;
  inset: -6px -6px -6px -6px;
  border-radius: 16px;
  border: 1px dashed #34405c;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b6c3df;
  font-size: 14px;
}

/* Budget modal */
.budget-modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 999;
}
.budget-modal {
  width: min(520px, 92vw);
  background: #0f172a;
  color: #e6ecff;
  border: 1px solid #24304b;
  border-radius: 12px;
  padding: 16px;
  position: relative;
}
.modal-close-btn {
  position: absolute; top: 8px; right: 8px;
  width: 32px; height: 32px; border-radius: 50%;
  border: 1px solid #2b3550; background: #0b1220; color: #dbeafe;
  cursor: pointer;
}

/* Small helpers */
.no-results { color: #b9c0d4; margin-top: 8px; }
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Dashboard.css"],"names":[],"mappings":";;AAEA;;;;;;;;;;;GAWG;AACH;IACI,gBAAgB;AACpB;AACA;;;;;;;;;;;;GAYG;;AAEH;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,iBAAiB;;AAErB;AACA;IACI,8BAA8B;IAC9B,aAAa,EAAE,iDAAiD;IAChE,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;;AAExB;AACA;IACI,aAAa;IACb,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,SAAS;IACT,iBAAiB;IACjB,gBAAgB,EAAE,4CAA4C;IAC9D,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,uDAAuD;IACvD,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,oCAAoC;AACxC;AACA;IACI,gEAAgE;IAChE,uBAAuB;IACvB,oBAAoB;;AAExB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB,CAAC;IACG,iBAAiB;IACjB,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA,gCAAgC;;AAEhC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;IACjB,uDAAuD;IACvD,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;AACjD;;;AAGA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,uDAAuD;IACvD,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;;mDAE+C;IAC/C,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB,CAAC;IACG,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;AACA,6BAA6B;AAC7B;IACI,qDAAqD;IACrD,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,8CAA8C;IAC9C,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;MACtC,gBAAgB;EACpB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;;QAEI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;IACA;;QAEI,6BAA6B;QAC7B,2BAA2B;QAC3B,0BAA0B;IAC9B;IACA;QACI,uCAAuC;IAC3C;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,qBAAqB;QACrB,yBAAyB;IAC7B;IACA;QACI,uBAAuB;QACvB,4BAA4B;IAChC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,cAAc;IAClB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,cAAc;EAChB;EACA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;EACA,mBAAmB;EACnB;IACE,yBAAyB,EAAE,qBAAqB;IAChD,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,8BAA8B;EAC9B;IACE,WAAW,EAAE,yBAAyB;IACtC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;EAC7B;;EAEA,2BAA2B;EAC3B;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;IAChD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW,EAAE,mDAAmD;EAClE;;EAEA;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;;IAEf,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,6CAA6C;EAC7C;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B;IACE,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;EACvB;EACA,yDAAyD;AAC3D;EACE,yBAAyB;EACzB,wBAAwB,cAAc,cAAc;EACpD,0BAA0B,YAAY,gBAAgB;EACtD,uBAAuB,eAAe,sBAAsB;EAC5D,uBAAuB;;EAEvB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;;EAEvB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,cAAc;EACd,uBAAuB;;EAEvB,iBAAiB;EACjB,kFAAkF;EAClF,uEAAuE;EACvE,kEAAkE;;EAElE,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;;EAE3C,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;;EAGE,8BAA8B;EAC9B;IACE,sBAAsB;EACxB;;EAEA;;EAEA,oGAAoG;;;IAGlG,0BAA0B;IAC1B,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;;AAEF,oCAAoC;AACpC;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,6CAA6C;;;CAG9C;;+EAE8E;EAC7E,4BAA4B;EAC5B,gCAAgC;EAChC,6CAA6C;AAC/C;;;EAGE,+BAA+B;AACjC;EACE,YAAY;EACZ,2EAA2E,EAAE,8BAA8B;EAC3G,sDAAsD;EACtD,uCAAuC;;EAEvC,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;;EAExB,2BAA2B;EAC3B,mDAAmD;;EAEnD,qCAAqC,EAAE,4BAA4B;AACrE;AACA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,oDAAoD,EAAE,uBAAuB;AAC/E;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC,EAAE,kCAAkC;AAC/E;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC,EAAE,qBAAqB;EAC7D,qDAAqD,EAAE,cAAc;EACrE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,wCAAwC;EACxC,WAAW;EACX,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,4CAA4C,EAAE,wBAAwB;AACxE;;EAEE,kCAAkC;EAClC;IACE,kBAAkB;IAClB,SAAO;IACP,0BAA0B;IAC1B,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,mCAAmC;IACnC,6BAA6B;IAC7B,0CAA0C;IAC1C,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,kBAAkB;EACpB;;EAEA,gCAAgC;CACjC;EACC,qDAAqD,EAAE,eAAe;EACtE,0BAA0B;EAC1B,+BAA+B;EAC/B,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;;EAEhC,4BAA4B;EAC5B;+FAC6F;AAC/F;;;EAGE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA,sCAAsC;AACxC;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC,EAAE,0BAA0B;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC;;;kFAGgF;EAChF,0BAA0B;EAC1B,yBAAyB;AAC3B;;;EAGE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;IAC/B,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,2CAA2C;IAC3C,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qFAAqF;IACrF,sCAAsC;EACxC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;;IAEE,mCAAmC;IACnC,0BAA0B;IAC1B,YAAY;IACZ,4CAA4C;IAC5C,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,sCAAsC;EACxC;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;EAC9B;;;;;;;AAOF;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;;EAEhB;;;;;;;;GAQC;EACD,0BAA0B;EAC1B,gCAAgC;AAClC;;;;EAIE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,6CAA6C;IAC7C,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oFAAoF;IACpF,sCAAsC;EACxC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,8BAA8B;EAChC;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;IAC5B,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,mCAAmC;IACnC,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,+CAA+C;IAC/C,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;EACA,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC;;;;GAIC;EACD;;;;;;;;;KASG;EACH,0BAA0B;EAC1B,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;EACtC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;AAClC;;;EAGE,4BAA4B;EAC5B;IACE,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,gCAAgC;IAChC,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;EACnB;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+CC;;EAEC,2BAA2B;EAC3B;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,4CAA4C;IAC9C;;IAEA;MACE,aAAa;MACb,gBAAgB;MAChB,0BAA0B;MAC1B,sBAAsB;IACxB;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,kBAAkB;MAClB,0BAA0B;MAC1B,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;MAClB,gCAAgC;IAClC;;IAEA;;;MAGE,0BAA0B;IAC5B;;IAEA;;MAEE,0BAA0B;MAC1B,sBAAsB;IACxB;;IAEA;;MAEE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;;MAGE,0BAA0B;IAC5B;;IAEA;;;MAGE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;MAEE,4CAA4C;MAC5C,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;MACtB,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,4CAA4C;IAC9C;EACF;;EAEA,kCAAkC;EAClC;IACE,UAAU;EACZ;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yCAAyC;IACzC,kBAAkB;IAClB,kCAAkC;IAClC,+BAA+B;EACjC;;EAEA,8BAA8B;EAC9B;IACE,kCAAkC;IAClC,wCAAwC;EAC1C;;EAEA;IACE,mCAAmC;IACnC,wCAAwC;EAC1C;;EAEA,6BAA6B;EAC7B;;IAEE,uCAAuC;IACvC,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE;MACE,uBAAuB;MACvB,yBAAyB;MACzB,qBAAqB;IACvB;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,qCAAqC;MACrC,uCAAuC;MACvC,sCAAsC;IACxC;EACF;EACA,2DAA2D;;AAE7D,+DAA+D;AAC/D;IACI;MACE,cAAc;MACd,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA,iDAAiD;EACjD;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,4CAA4C;IAC9C;;IAEA;MACE,aAAa;MACb,kBAAkB;MAClB,aAAa;MACb,SAAS;IACX;;IAEA;MACE,UAAU;MACV,aAAa;MACb,kBAAkB;MAClB,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,cAAc;IAChB;EACF;;;EAGA;IACE,aAAa;IACb,2DAA2D;IAC3D,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;EAClC;;;EAGA;;;iEAG+D;;AAEjE,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;iEAEiE;AACjE;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,OAAO,QAAQ,IAAI;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,QAAQ,IAAI;AACrB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,6CAA6C;;AAE/C;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;AACA;;EAEE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;;AAEA;;iEAEiE;AACjE;EACE,uBAAuB;EACvB,eAAe;EACf,QAAQ,yBAAyB,2CAA2C;EAC5E,2BAA2B;;EAE3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,sCAAsC;EACtC,aAAa;;EAEb,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;;EAElB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB,gBAAgB,0BAA0B;EAC1D,WAAW;EACX,sCAAsC;;EAEtC,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW,EAAE,aAAa;EAC1B,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE;IACE,YAAY;EACd;EACA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;;;;AAKA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;EAC/B,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;;AAGA;EACE;IACE,wBAAwB;IACxB,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,yEAAyE;AACzE;EACE,mBAAmB,oBAAoB,uBAAuB;EAC9D,yBAAyB,cAAc,4BAA4B;EACnE,8BAA8B,SAAS,kDAAkD;EACzF,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,cAAc,0BAA0B,wBAAwB;AAClE;AACA;EACE,aAAa;EACb,cAAc,0BAA0B,eAAe;AACzD;;AAEA,wEAAwE;AACxE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc,yBAAyB,kBAAkB;EACzD,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;;;AAIA,0EAA0E;;AAE1E;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B,IAAI,wBAAwB;EAC1D,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,cAAc,GAAG,yBAAyB;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;;;;;;AAOA,sBAAsB;AACtB;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA,eAAe,0BAA0B,EAAE;;AAE3C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,iBAAiB,qCAAqC,EAAE;AAC1D;AACA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,WAAW,EAAE,mBAAmB,EAAE;;AAEzD,gBAAgB;AAChB;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,oDAAoD;EACpD,qCAAqC;AACvC;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,qBAAqB,qCAAqC,EAAE;AAC9D;AACA;EACE,qBAAqB,0BAA0B,EAAE;AACnD;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA,sBAAsB,eAAe,EAAE;AACvC,6BAA6B,cAAc,EAAE,eAAe,EAAE;AAC9D;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAErE,oCAAoC;AACpC;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB,IAAI,2BAA2B;EACnD,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe,EAAE,QAAQ;EACzB,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB,EAAE,QAAQ,EAAE,UAAU;EACxC,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,yBAAyB,EAAE,mBAAmB,EAAE,cAAc;EAC9D,eAAe;AACjB;;AAEA,kBAAkB;AAClB,cAAc,cAAc,EAAE,eAAe,EAAE","sourcesContent":["\n\n/* .dashboard-container {\n    padding-top: 80px; \n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n\n.dashboard-main {\n    max-width: 1200px;\nmargin-top: 200px;\nmargin-left: 200px;\n    padding: 20px;\n} */\n.header-area{\n    background:black;\n}\n/* .dashboard-content {\n    background: white;\n    border-radius: 8px;\n    padding: 24px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n} */\n\n.recommendations-button {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    margin-left:1350px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.edit-questionnaire-button:hover {\n    background-color: #0056b3;\n}\n.edit-questionnaire-button {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    /* margin-left: 600px; */\n    /* font-size: larger; */\n    font-weight: 1000;\n}\n\n.recommendations-button:hover {\n    background-color: #0056b3;\n}\n.main-heading {\n    text-align: center;\n    margin-bottom: 30px;\n    margin-top: 300px;\n    font-family: Noto Serif Georgian;\n    font-size: 50px;\n    font-weight: 1000; \n    color: rgb(46, 119, 176);\n    text-align: center;\n    line-height: 1.5;\n    border-radius: 0px;\n    opacity: 1;\n}\n.profile-main-heading {\n    text-align: center;\n    margin-bottom: 30px;\n    font-family: Noto Serif Georgian;\n    font-size: 50px;\n    font-weight: 1000; \n    color: rgb(46, 119, 176);\n    text-align: center;\n    line-height: 1.5;\n    border-radius: 0px;\n    opacity: 1;\n}\n\n.questionnaire-summary-box {\n    /* width: 1500px !important; */\n    /* height: 400px; */\n    /* background-color: #007bff; */\n    border-radius: 15px;\n    border:6px solid #007bff;\n    padding: 20px;\n    margin: 20px auto;\n    \n}\n.profile-summary-box {\n    /* width: 1500px !important; */\n    height: 565px; /* Increased height to accommodate more content */\n    border-radius: 15px;\n    border: 6px solid #007bff;\n    padding: 20px;\n    margin: 20px auto;\n}\n\n.questionnaire-summary-box h3 {\n    text-align: center;\n    margin-bottom: 30px;\n}\n.profile-summary-box h3 {\n    text-align: center;\n    margin-bottom: 30px;\n}\n.questionnaire-details {\n    padding: 20px;\n    justify-self: center;\n    \n}\n.profile-details {\n    padding: 20px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Create two columns */\n    gap: 10px;\n    max-height: 400px;\n    overflow-y: auto; /* Add scrolling if content exceeds height */\n    /* margin-left: 263px; */\n}\n.profile-details p {\n    margin: 10px 0;\n    font-size: 16px;\n    display: flex;\n    justify-content: left;\n    align-items: center;\n}\n\n.profile-details p strong {\n    min-width: 150px;\n    text-align: left;\n    margin-right: 15px;\n    color: #2c3e50;\n    font-weight: 500;\n}\n\n.questionnaire-details p {\n    margin: 15px 0;\n    font-size: 18px;\n}\n.profile-summary-box p {\n    margin: 15px 0;\n    font-size: 18px;\n}\n.edit-profile-button:hover {\n    background-color: #0056b3;\n}\n.edit-profile-button {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    width: fit-content;\n    font-size: larger;\n    font-weight: 1000;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: white;\n    padding: 2rem;\n    border-radius: 8px;\n    max-width: 600px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n.edit-questionnaire-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.edit-questionnaire-modal {\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n}\n\n.button-group {\n    display: flex;\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.edit-questionnaire-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 2rem;\n    backdrop-filter: blur(5px);\n}\n\n.edit-questionnaire-modal {\n    position: relative;\n    background: linear-gradient(to right, #ffffff, #f8f9fa);\n    border-radius: 15px;\n    padding: 0rem;\n    width: 100%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    animation: modalFadeIn 0.4s ease-out;\n}\n.cancel-btn {\n    background: linear-gradient(135deg, #dc3545, #c82333) !important;\n    color: white !important;\n    border: 0 !important;\n   \n}\n.edit-questionnaire-modal form {\n    padding: 2rem;\n}\n\n.edit-questionnaire-modal h2 {\n    color: #ffffff;\n    font-size: 18px;\n    text-align: center;\n    margin-bottom: 2rem;\n    font-weight: 600;\n    background: #3498db;\n    padding: 1rem;\n    \n}\n\n.button-group {\n    display: flex;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.button-group button {\n    flex: 1;\n    padding: 0.8rem 1.5rem;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.button-group button[type=\"submit\"] {\n    background: linear-gradient(135deg, #3498db, #2980b9);\n    color: white;\n    border: none;\n}\n\n.button-group button[type=\"submit\"]:hover {\n    background: linear-gradient(135deg, #2980b9, #2c3e50);\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(41, 128, 185, 0.3);\n}\n\n.button-group button[type=\"button\"] {\n    background: white;\n    color: #2c3e50;\n    border: 2px solid #e0e0e0;\n}\n\n.button-group button[type=\"button\"]:hover {\n    background: #f8f9fa;\n    border-color: #3498db;\n}.logout-button {\n    padding: 12px 4px;\n    background: linear-gradient(135deg, #e74c3c, #c0392b);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-left: 1rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.logout-button:hover {\n    background: linear-gradient(135deg, #c0392b, #962d22);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(231, 76, 60, 0.2);\n}\n\n.logout-button:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);\n}\n\n/* Documents Upload Block css  */\n\n.documents-main-heading {\n    text-align: center;\n    margin-bottom: 30px;\n    font-family: Noto Serif Georgian;\n    font-size: 50px;\n    font-weight: 1000; \n    color: rgb(46, 119, 176);\n    text-align: center;\n    line-height: 1.5;\n    border-radius: 0px;\n    opacity: 1;\n}\n\n.documents-summary-box {\n    /* width: 1500px !important; */\n    height: 400px;\n    border-radius: 15px;\n    border: 6px solid  #007bff;\n    padding: 20px;\n    margin: 20px auto;\n    background: linear-gradient(to right, #ffffff, #f8f9fa);\n    box-shadow: 0 8px 16px rgba(0,0,0,0.1);\n}\n\n.documents-summary-box h3 {\n    text-align: center;\n    margin-bottom: 30px;\n    color: #2c3e50;\n    font-size: 1.75rem;\n}\n\n.documents-details {\n    padding: 40px;\n    text-align: center;\n}\n\n.documents-details p {\n    margin: 15px 0;\n    font-size: 20px;\n    line-height: 1.6;\n    color: #34495e;\n}\n\n.upload-documents-button {\n    padding: 15px 30px;\n    background: linear-gradient(135deg, #0056b3, #0056b3);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 18px;\n    font-weight: 600;\n    /* margin-left: 600px; */\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(76, 175, 80, 0.2);\n}\n\n.upload-documents-button:hover {\n    background: linear-gradient(135deg, #1e12c5, #121758);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(16, 80, 218, 0.3);\n}\n\n\n/* Checklist css */\n\n.checklist-main-heading {\n    text-align: center;\n    margin-bottom: 30px;\n    font-family: Noto Serif Georgian;\n    font-size: 50px;\n    font-weight: 1000;\n    color: rgb(46, 119, 176);\n    line-height: 1.5;\n}\n\n.checklist-summary-box {\n    /* width: 1500px !important; */\n    height: 400px;\n    border-radius: 15px;\n    border: 6px solid #007bff;\n    padding: 20px;\n    margin: 20px auto;\n    background: linear-gradient(to right, #ffffff, #f8f9fa);\n    box-shadow: 0 8px 16px rgba(0, 123, 255, 0.1);\n}\n\n.checklist-summary-box h3 {\n    text-align: center;\n    margin-bottom: 30px;\n    color: #2c3e50;\n    font-size: 1.75rem;\n}\n\n.checklist-details {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    padding: 20px 40px;\n}\n\n.checklist-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px;\n    background: white;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0;\n    transition: all 0.3s ease;\n}\n\n.checklist-item:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.1);\n    border-color: #007bff;\n}\n\n.checklist-item span {\n    font-size: 16px;\n    color: #2c3e50;\n    font-weight: 500;\n}\n\n.check-icon {\n    font-size: 24px;\n    color: #d37b7b;\n    transition: all 0.3s ease;\n}\n\n.checklist-item:hover .check-icon {\n    transform: scale(1.2);\n}\n\n.questionnaire-details {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /* gap: 20px; */\n    padding: 10px;\n}\n\n.detail-item {\n    display: flex;\n    align-items: center;\n    /* gap: 15px; */\n    width: 100%;\n    max-width: 600px;\n}\n\n.detail-label {\n    font-weight: 500;\n    color: #2c3e50;\n    min-width: 210px;\n    text-align: right;\n}\n\n.detail-value {\n    color: #646464;\n    font-size: 16px;\n    padding: 8px 16px;\n    /* background: rgba(255, 255, 255, 0.9);\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1); */\n    flex-grow: 1;\n    text-align: left;\n}\n.document-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    backdrop-filter: blur(5px);\n}\n\n.document-modal-content {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 80%;\n    max-height: 80%;\n    overflow: auto;\n    position: relative;\n}\n\n.close {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    font-size: 24px;\n    cursor: pointer;\n}\n\n.checklist-item {\n    cursor: pointer;\n}\n\n.fa-times-circle {\n    color: #dc3545;\n}\n.fa-check-circle {\n    /* color: #28a745; */\n}.document-modal-content {\n    width: 90%;\n    height: 90vh;\n    background: white;\n    padding: 20px;\n    position: relative;\n}\n\n.document-modal-content iframe {\n    background: white;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n/* Modern Dashboard Styling */\n.dashboard-container {\n    background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n    min-height: 100vh;\n}\n\n.main-heading, .profile-main-heading, .documents-main-heading, .checklist-main-heading {\n    font-family: 'Poppins', sans-serif;\n    font-size: 42px;\n    color: #1a73e8;\n    margin: 40px 0;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    position: relative;\n}\n\n.main-heading::after {\n    content: '';\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100px;\n    height: 4px;\n    background: linear-gradient(90deg, #1a73e8, #34a853);\n    border-radius: 2px;\n}\n\n.questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {\n    background: white;\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n    margin: 30px auto;\n    padding: 30px;\n    text-align:center;\n}\n\n.questionnaire-summary-box:hover, .profile-summary-box:hover {\n    /* transform: translateY(-5px); */\n}\n\n.edit-questionnaire-button, .edit-profile-button, .upload-documents-button, .recommendations-button {\n    background: linear-gradient(135deg, #1a73e8, #4285f4);\n    color: white;\n    padding: 12px 30px;\n    border-radius: 25px;\n    font-weight: 400;\n    border: none;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(26, 115, 232, 0.2);\n    margin-top: 40px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n\n.edit-questionnaire-button:hover, .edit-profile-button:hover {\n    background: linear-gradient(135deg, #4285f4, #1a73e8);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(26, 115, 232, 0.3);\n}\n\n.profile-details {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0px;\n    padding: 20px;\n}\n\n.profile-details p {\n    /* background: #f8f9fa; */\n    padding: 15px;\n    /* border-radius: 10px; */\n    margin: 0;\n    transition: all 0.3s ease;\n    border: 1px solid #e8e8e8;\n}\n\n.profile-details p:hover {\n    /* background: #e9ecef; */\n    /* transform: translateX(5px); */\n}\n\n/* Sidebar styling */\n.sidebar {\n    width: 250px;\n    background: #2c3e50;\n    color: #ecf0f1;\n    /* height: 100vh; */\n    display: flex;\n    flex-direction: column;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);\n      position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  flex-shrink: 0;\n  z-index: 10;\n}\n\n.sidebar .logo {\n    text-align: center;\n    padding: 20px;\n    background: #111827;\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.sidebar ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar ul li {\n    font-size: 12px;\n    padding: 14px 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    transition: background 0.3s ease;\n    border-bottom: 1px solid #5a5a5a;\n}\n\n.sidebar ul li:hover {\n    background: #34495e;\n}\n\n.sidebar ul li i {\n    font-size: 1.2rem;\n}\n\n.sidebar ul li.active {\n    background: #1a73e8;\n}\n\n/* Main content */\n.content {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n}\n\n.tab-content {\n    display: none;\n}\n\n.tab-content.active {\n    display: block;\n}\n\n.tab-content h2 {\n    font-size: 2rem;\n    color: #2c3e50;\n    margin-bottom: 10px;\n}\n\n.tab-content p {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #555;\n}\n\n.dashboard-container {\n    display: flex;\n}\n.authenticated-main {\n    padding: 0px !important;\n    margin-top: 70px !important;\n}\n\n.tab-content h2 {\n    padding: 15px;\n    background: #2596be;\n    color: #ffffff;\n    font-size: 18px;\n}\n\n.questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {\n    background: transparent !important;\n    box-shadow: unset !important;\n}\n.content {\n    background-color: #ffffff;\n    padding: 0 !important;\n}\n.detail-item {\n    border: 1px solid #e8e8e8;\n}\n.detail-label, .detail-value {\n    /* border: 1px solid #e8e8e8; */\n    line-height: 21px;\n    font-size: 14px;\n    padding: 15px;\n}\n.detail-label {\n    text-align: left;\n}\n\n.profile-details p span {\n    display: inline-block;\n    width: 50%;\n    text-align: left;\n}\n\n@media (max-width: 768px) {\n    \n    .sidebar ul li span, .sidebar .logo {\n        display: none;\n    }\n    .sidebar {\n        width: auto;\n    }\n    \n    .questionnaire-summary-box, .documents-summary-box, .checklist-summary-box {\n        height: auto !important;\n        padding: 16px !important;\n    }\n    .questionnaire-summary-box h3, .documents-summary-box h3, .tab-content h2,\n    .profile-summary-box h3, .checklist-summary-box h3 {\n        font-size: 16px !important;\n    }\n    .detail-label {\n        min-width: auto !important;\n        text-align: left !important;\n    }\n    .detail-value {\n        text-align: right !important;\n    }\n    .edit-questionnaire-button, .edit-profile-button, .upload-documents-button, .recommendations-button {\n\n        padding: 10px 15px !important;\n        font-weight: 500 !important;\n        font-size: 16px !important;\n    }\n    .checklist-details {\n        grid-template-columns: unset !important;\n    }\n    .profile-details p strong {\n        min-width: auto !important;\n    }\n    .profile-details {\n        padding: 0 !important;\n        display: block !important;\n    }\n    .profile-summary-box, .profile-details {\n        height: auto !important;\n        max-height: unset !important;\n    }\n    .questionnaire-summary-box, .profile-summary-box, .documents-summary-box, .checklist-summary-box {\n        padding: 30px 15px !important;\n    }\n    .checklist-details {\n        padding: 20px 15px !important;\n    }\n    \n    .tab-content h2 {\n        padding: 15px;\n        background: #2596be;\n        color: #ffffff;\n    }\n    \n    \n    .profile-details p span:nth-child(odd) {\n        text-align: left;\n    }\n    \n    .profile-details p span:nth-child(even) {\n        text-align: right;\n    }\n    .chatbot-container {\n        max-width: 300px !important;\n    }\n    .message {\n        max-width: 80% !important;\n    }\n}\n\n/* Main container for the chatbot */\n.chatbot-container {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    max-width: 400px;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    width: 350px;\n    resize: both;\n    overflow: auto;\n  }\n  .recommendation-button, .chatbot-footer button {\n    background-color: transparent; \n    border: 2px solid #1a73e8;\n    color: #1a73e8;\n  }\n  .recommendation-button:hover {\n    background-color: #1a73e8 !important;\n    color: #ffffff !important;\n  }\n  /* Header section */\n  .chatbot-header {\n    background-color: #1a73e8; /* Your theme color */\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    color: #fff;\n    font-size: 16px;\n    font-weight: bold;\n    position: relative;\n  }\n  \n  /* Logo position and styling */\n  .chatbot-header img {\n    width: 40px; /* Adjust the logo size */\n    height: auto;\n    margin-right: 10px;\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  \n  /* Close button on header */\n  .chatbot-header button {\n    background: transparent;\n    border: none;\n    color: white;\n    font-size: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  \n  /* Body section */\n  .chatbot-body {\n    padding: 10px;\n    max-height: 300px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Message bubbles */\n  .message {\n    max-width: 70%;\n    padding: 10px 15px;\n    border-radius: 20px;\n    margin: 5px 0;\n    word-wrap: break-word;\n  }\n  \n  .message.user {\n    background-color: #1a73e8;\n    align-self: flex-end;\n    border-radius: 20px 20px 0 20px;\n  }\n  \n  .message.bot {\n    background-color: #f1f1f1;\n    align-self: flex-start;\n    border-radius: 20px 20px 20px 0;\n  }\n  \n  /* FAQ suggestions container */\n  .chatbot-faqs {\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n  }\n  \n  .faq-button {\n    background-color: #2596be; /* Your theme color */\n    color: white;\n    border: none;\n    padding: 10px 15px;\n    margin: 5px 0;\n    border-radius: 20px;\n    cursor: pointer;\n    text-align: center;\n    font-size: 14px;\n    width: 100%; /* Take full width to make it blend into the chat */\n  }\n  \n  .faq-button:hover {\n    background-color: #1f82a1; /* Darker shade for hover effect */\n  }\n  \n  /* Footer with input */\n  .chatbot-footer {\n    display: flex;\n    padding: 10px;\n    background: #f9f9f9;\n    border-top: 1px solid #e0e0e0;\n  }\n  \n  .chatbot-footer input {\n    flex-grow: 1;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 20px;\n    margin-right: 10px;\n    font-size: 14px;\n  }\n  \n  .chatbot-footer button {\n    background-color: #1a73e8;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 16px;\n    \n    width: 44px !important;\n    height: 44px !important;\n  }\n  \n  .chatbot-footer button:hover {\n    background-color: #1f82a1;\n  }\n  \n  /* Make chat icon smaller and more centered */\n  .chat-icon {\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    background-color: #1a73e8;\n    border-radius: 50%;\n    padding: 15px;\n    color: white;\n    font-size: 22px;\n    cursor: pointer;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  }\n  \n  .chat-icon:hover {\n    background-color: #1f82a1;\n  }\n  \n  /* Typing animation for bot */\n  .chatbot-typing-logo {\n    width: 30px;\n    height: auto;\n    animation: typing 1.5s infinite ease-in-out;\n    margin-right: 10px;\n  }\n  \n  /* Animation for typing effect */\n  @keyframes typing {\n    0% { opacity: 0.5; }\n    50% { opacity: 1; }\n    100% { opacity: 0.5; }\n  }\n  /* ===== CSS VARIABLES FROM SINGLEPOSTPAGE DESIGN ===== */\n:root {\n  /* 🔵 Core Theme Colors */\n  --primary-color: #1E3A8A;             /* Deep Blue */\n  --secondary-color: #3B82F6;           /* Bright Blue */\n  --accent-color: #60A5FA;              /* Light Blue Accent */\n  --danger-color: #ea4335;\n\n  /* 🌑 Dark Mode Backgrounds */\n  --dark-bg: #0f1419;\n  --dark-card: #111827;\n  --dark-surface: #1f2937;\n\n  /* 🖋️ Text Colors */\n  --text-primary: #ffffff;\n  --text-secondary: #cbd5e1;\n  --text-muted: #8a9ba8;\n\n  /* 🧱 Border */\n  --border-color: #374151;\n\n  /* 🎨 Gradients */\n  --gradient-primary: linear-gradient(135deg, #1E3A8A 0%, #3B82F6 50%, #60A5FA 100%);\n  --gradient-secondary: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  --gradient-dark: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 100%);\n\n  /* 🕶️ Shadows */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.6);\n\n  /* 🟦 Border Radius */\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n\n  /* 📐 Spacing Scale */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n  --spacing-3xl: 64px;\n\n  /* 🕒 Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n}\n\n  \n  /* ===== GLOBAL STYLES ===== */\n  * {\n    box-sizing: border-box;\n  }\n  \n  body {\n    \n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;\n\n\n    background: var(--dark-bg);\n    color: var(--text-primary);\n    margin: 0;\n    padding: 0;\n    line-height: 1.6;\n  }\n  \n/* ===== DASHBOARD CONTAINER ===== */\n.dashboard-container {\n  display: flex;\n  min-height: 100vh;\n  background: var(--dark-bg);\n  position: relative;\n  font-family: 'Poppins', sans-serif !important;\n\n\n background-image: \n    radial-gradient(circle at top left, rgba(255,255,255,0.015), transparent),\n    radial-gradient(circle at bottom right, rgba(59,130,246,0.05), transparent);\n  backdrop-filter: blur(1.5px);\n  transition: background 0.5s ease;\n  font-family: 'Poppins', sans-serif !important;\n}\n\n  \n  /* ===== SIDEBAR DESIGN ===== */\n.sidebar {\n  width: 280px;\n  background: linear-gradient(to bottom, #111827 0%, #1f2937 100%) !important; /* Clean dark vertical blend */\n  border-right: 1px solid var(--border-color) !important;\n  box-shadow: var(--shadow-lg) !important;\n  \n  position: fixed !important;\n  height: 100vh !important;\n  left: 0 !important;\n  top: 0 !important;\n  z-index: 1000 !important;\n  \n  overflow-y: auto !important;\n  transition: all var(--transition-normal) !important;\n  \n  backdrop-filter: blur(8px) !important; /* Softens hard dark edges */\n}\n.sidebar-header {\n  padding: var(--spacing-xl);\n  border-bottom: 1px solid var(--border-color);\n  background: var(--dark-card);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.04); /* added subtle depth */\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-align: center;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4); /* better legibility on gradient */\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: var(--spacing-lg) 0;\n  margin: 0;\n}\n\n.sidebar ul li {\n  margin: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-normal);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.015); /* gentle card lift */\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02); /* soft edge */\n  will-change: transform, color;\n}\n\n.sidebar ul li::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: var(--gradient-primary);\n  transition: all var(--transition-normal);\n  z-index: -1;\n  filter: brightness(1.05) saturate(1.1);\n  opacity: 0.9;\n}\n\n.sidebar ul li:hover::before,\n.sidebar ul li.active::before {\n  left: 0;\n}\n\n.sidebar ul li span {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-lg);\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all var(--transition-normal);\n  position: relative;\n  z-index: 1;\n}\n\n.sidebar ul li:hover span,\n.sidebar ul li.active span {\n  color: var(--text-primary);\n  transform: translateX(4px);\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.sidebar ul li i {\n  font-size: 1.2rem;\n  width: 24px;\n  text-align: center;\n  transition: all var(--transition-normal);\n}\n\n.sidebar ul li:hover i,\n.sidebar ul li.active i {\n  transform: scale(1.1);\n  color: var(--text-primary);\n}\n\n.sidebar ul li.active {\n  border: 1px solid rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 10px rgba(59, 130, 246, 0.3); /* glowing active item */\n}\n\n  /* ===== MAIN CONTENT AREA ===== */\n  .content {\n    margin-left: 280px;\n    flex: 1;\n    background: var(--dark-bg);\n    min-height: 100vh;\n    padding: var(--spacing-2xl);\n  }\n  \n  /* ===== TAB CONTENT ===== */\n  .tab-content {\n    display: none;\n    animation: fadeInUp 0.6s ease-out;\n  }\n  \n  .tab-content.active {\n    display: block;\n  }\n  \n  .tab-content h2 {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: var(--spacing-2xl);\n    background: var(--gradient-primary);\n    -webkit-background-clip: text;\n    /* -webkit-text-fill-color: transparent; */\n    background-clip: text;\n    text-align: center;\n    position: relative;\n  }\n  \n  .tab-content h2::after {\n    content: '';\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 80px;\n    height: 4px;\n    background: var(--gradient-primary);\n    border-radius: 2px;\n  }\n  \n  /* ===== DASHBOARD CARDS ===== */\n .dashboard-card {\n  background: linear-gradient(145deg, #111827, #1a1f2e); /* dark blend */\n  color: var(--text-primary);\n  border-radius: var(--radius-lg);\n  border: 1px solid rgba(59, 130, 246, 0.1);\n  box-shadow: 0 0 10px rgba(59, 130, 246, 0.05);\n  padding: var(--spacing-2xl);\n  backdrop-filter: blur(2px);\n  transition: background 0.4s ease;\n\n  /* Optional visual texture */\n  background-image: radial-gradient(circle at top left, rgba(59,130,246,0.04), transparent),\n                    radial-gradient(circle at bottom right, rgba(59,130,246,0.06), transparent);\n}\n\n  \n  .dashboard-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: var(--gradient-primary);\n  }\n  \n  .dashboard-card:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-xl);\n    border-color: var(--primary-color);\n  }\n  \n  .dashboard-card h3 {\n    color: var(--text-primary);\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin-bottom: var(--spacing-lg);\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-md);\n  }\n  \n  .dashboard-card h3 i {\n    color: var(--primary-color);\n    font-size: 1.3rem;\n  }\n  \n  .dashboard-card p {\n    color: var(--text-secondary);\n    font-size: 1rem;\n    line-height: 1.6;\n    margin-bottom: var(--spacing-lg);\n  }\n  \n  /* ===== QUESTIONNAIRE SUMMARY ===== */\n.questionnaire-summary-box {\n  background: var(--dark-card);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-2xl);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3); /* slightly softer depth */\n  position: relative;\n  overflow: hidden;\n  margin-bottom: var(--spacing-xl);\n  background-image: \n    linear-gradient(135deg, rgba(26, 115, 232, 0.06), rgba(17, 24, 39, 0.9)),\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.015), transparent),\n    radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.03), transparent);\n  backdrop-filter: blur(2px);\n  transition: all 0.4s ease;\n}\n\n  \n  .questionnaire-summary-box::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: var(--gradient-primary);\n  }\n  \n  .questionnaire-summary-box h3 {\n    color: var(--text-primary);\n    font-size: 1.75rem;\n    font-weight: 600;\n    margin-bottom: var(--spacing-xl);\n    text-align: center;\n  }\n  \n  .questionnaire-details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: var(--spacing-lg);\n    margin-bottom: var(--spacing-xl);\n  }\n  \n  .detail-item {\n    background: var(--dark-surface);\n    padding: var(--spacing-lg);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    border-left: 4px solid var(--primary-color);\n    transition: all var(--transition-normal);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .detail-item::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(26, 115, 232, 0.1), transparent);\n    transition: all var(--transition-slow);\n  }\n  \n  .detail-item:hover::before {\n    left: 100%;\n  }\n  \n  .detail-item:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n    border-left-color: var(--secondary-color);\n  }\n  \n  .detail-label {\n    display: block;\n    font-weight: 600;\n    color: var(--text-muted);\n    font-size: 0.85rem;\n    margin-bottom: var(--spacing-sm);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .detail-value {\n    display: block;\n    font-weight: 500;\n    color: var(--text-primary);\n    font-size: 1.1rem;\n  }\n  \n  /* ===== BUTTONS ===== */\n  .edit-questionnaire-button,\n  .edit-profile-button {\n    background: var(--gradient-primary);\n    color: var(--text-primary);\n    border: none;\n    padding: var(--spacing-md) var(--spacing-xl);\n    border-radius: var(--radius-md);\n    font-weight: 600;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing-sm);\n    margin: 0 auto;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .edit-questionnaire-button::before,\n  .edit-profile-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    transition: all var(--transition-slow);\n  }\n  \n  .edit-questionnaire-button:hover::before,\n  .edit-profile-button:hover::before {\n    left: 100%;\n  }\n  \n  .edit-questionnaire-button:hover,\n  .edit-profile-button:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-lg);\n  }\n\n\n\n\n\n  \n.profile-summary-box {\n  background-color: #111827 !important; /* lighter than #1a1f2e */\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-2xl);\n  border: 1px solid var(--primary-color);\n  box-shadow: 0 0 10px rgba(26, 115, 232, 0.1);\n  position: relative;\n  overflow: hidden;\n\n  background-image: radial-gradient(\n    circle at top left,\n    rgba(255, 255, 255, 0.04),\n    transparent\n  ), radial-gradient(\n    circle at bottom right,\n    rgba(59, 130, 246, 0.08),\n    transparent\n  );\n  backdrop-filter: blur(2px);\n  transition: background 0.4s ease;\n}\n\n\n  \n  .profile-summary-box::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: var(--gradient-primary);\n  }\n  \n  .profile-summary-box h3 {\n    color: var(--text-primary);\n    font-size: 1.75rem;\n    font-weight: 600;\n    margin-bottom: var(--spacing-xl);\n    text-align: center;\n  }\n  \n  .profile-details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: var(--spacing-md);\n    margin-bottom: var(--spacing-xl);\n  }\n  \n  .profile-details p {\n    display: flex;\n    align-items: center;\n    background: var(--dark-surface);\n    padding: var(--spacing-lg);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    margin-bottom: 0;\n    border-left: 4px solid var(--secondary-color);\n    transition: all var(--transition-normal);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .profile-details p::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(52, 168, 83, 0.1), transparent);\n    transition: all var(--transition-slow);\n  }\n  \n  .profile-details p:hover::before {\n    left: 100%;\n  }\n  \n  .profile-details p:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n  }\n  \n  .profile-details p span:first-child {\n    font-weight: 600;\n    color: var(--text-muted);\n    min-width: 140px;\n    font-size: 0.9rem;\n  }\n  .profile-details p span:last-child {\n    color: var(--text-primary);\n    font-weight: 500;\n    font-size: 1rem;\n    margin-left: var(--spacing-md);\n  }\n  \n  /* ===== FEATURE ITEMS ===== */\n  .feature-item {\n    text-align: center;\n    padding: var(--spacing-2xl);\n    background: var(--dark-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-md);\n    border: 1px solid var(--border-color);\n    transition: all var(--transition-normal);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .feature-item::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: var(--gradient-primary);\n  }\n  \n  .feature-item:hover {\n    transform: translateY(-8px);\n    box-shadow: var(--shadow-xl);\n    border-color: var(--primary-color);\n  }\n  \n  .feature-item i {\n    font-size: 3rem;\n    margin-bottom: var(--spacing-lg);\n    display: block;\n    background: var(--gradient-primary);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n  }\n  \n  .feature-item h4 {\n    margin: var(--spacing-lg) 0 var(--spacing-md) 0;\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n  \n  .feature-item p {\n    margin: 0;\n    color: var(--text-secondary);\n    font-size: 1rem;\n    line-height: 1.5;\n  }\n  \n  /* ===== PAYMENT SUCCESS ===== */\n  .payment-success {\n    text-align: center;\n    padding: var(--spacing-2xl);\n  }\n  \n  .payment-success h3 {\n    color: var(--secondary-color);\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: var(--spacing-lg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing-md);\n  }\n  \n  .payment-success h3::before {\n    content: '✅';\n    font-size: 2.5rem;\n  }\n  \n  .payment-success p {\n    color: var(--text-secondary);\n    font-size: 1.1rem;\n    line-height: 1.6;\n    margin-bottom: var(--spacing-xl);\n  }\n  \n  /* ===== BLUR CONTENT ===== */\n  .blur-content {\n    filter: blur(4px);\n    pointer-events: none;\n    position: relative;\n  }\n  \n  .blur-content::after {\n  content: '🔒 Complete Payment to Unlock';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: linear-gradient(\n    135deg,\n    rgba(26, 115, 232, 0.08),\n    rgba(17, 24, 39, 0.95)\n  );\n  background-image: radial-gradient(\n      circle at top left,\n      rgba(255, 255, 255, 0.02),\n      transparent\n    ),\n    radial-gradient(\n      circle at bottom right,\n      rgba(59, 130, 246, 0.06),\n      transparent\n    );\n  color: var(--text-primary);\n  padding: var(--spacing-lg) var(--spacing-xl);\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 1.1rem;\n  box-shadow: var(--shadow-lg);\n  border: 2px solid var(--primary-color);\n  z-index: 10;\n  pointer-events: all;\n  text-align: center;\n  backdrop-filter: blur(4px);\n  transition: background 0.4s ease;\n}\n\n  \n  /* ===== NOTE STYLES ===== */\n  .note {\n    background: rgba(251, 188, 4, 0.1);\n    border: 2px solid var(--accent-color);\n    border-radius: var(--radius-md);\n    padding: var(--spacing-lg);\n    margin-bottom: var(--spacing-xl);\n    color: var(--accent-color);\n    font-weight: 500;\n    text-align: center;\n    font-size: 1rem;\n    position: relative;\n  }\n  \n  .note::before {\n    content: '⚠️';\n    margin-right: var(--spacing-sm);\n    font-size: 1.2rem;\n  }\n/* \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n*/\n  \n  /* ===== ANIMATIONS ===== */\n  @keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes slideInRight {\n    from {\n      opacity: 0;\n      transform: translateX(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .animate-fade-in-up {\n    animation: fadeInUp 0.6s ease-out;\n  }\n  \n  /* ===== MOBILE RESPONSIVENESS ===== */\n  @media (max-width: 1024px) {\n    .sidebar {\n      width: 260px;\n    }\n    \n    .content {\n      margin-left: 260px;\n      padding: var(--spacing-xl);\n    }\n    \n    .tab-content h2 {\n      font-size: 2.25rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .sidebar {\n      width: 100%;\n      height: auto;\n      position: relative;\n      box-shadow: none;\n      border-right: none;\n      border-bottom: 1px solid var(--border-color);\n    }\n    \n    .sidebar ul {\n      display: flex;\n      overflow-x: auto;\n      padding: var(--spacing-md);\n      gap: var(--spacing-sm);\n    }\n    \n    .sidebar ul li {\n      margin: 0;\n      min-width: 120px;\n      flex-shrink: 0;\n    }\n    \n    .sidebar ul li span {\n      flex-direction: column;\n      text-align: center;\n      padding: var(--spacing-md);\n      font-size: 0.8rem;\n      gap: var(--spacing-xs);\n    }\n    \n    .sidebar ul li i {\n      font-size: 1.5rem;\n    }\n    \n    .content {\n      margin-left: 0;\n      padding: var(--spacing-lg);\n    }\n    \n    .tab-content h2 {\n      font-size: 1.75rem;\n      margin-bottom: var(--spacing-xl);\n    }\n    \n    .dashboard-card,\n    .questionnaire-summary-box,\n    .profile-summary-box {\n      padding: var(--spacing-sm);\n    }\n    \n    .questionnaire-details,\n    .profile-details {\n      grid-template-columns: 1fr;\n      gap: var(--spacing-md);\n    }\n    \n    .detail-item,\n    .profile-details p {\n      padding: var(--spacing-md);\n    }\n    \n    .profile-details p {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: var(--spacing-xs);\n    }\n    \n    .profile-details p span:first-child {\n      min-width: auto;\n      font-size: 0.8rem;\n    }\n    \n    .profile-details p span:last-child {\n      margin-left: 0;\n      font-size: 0.95rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .content {\n      padding: var(--spacing-md);\n    }\n    \n    .tab-content h2 {\n      font-size: 1.5rem;\n    }\n    \n    .dashboard-card,\n    .questionnaire-summary-box,\n    .profile-summary-box {\n      padding: var(--spacing-lg);\n    }\n    \n    .dashboard-card h3,\n    .questionnaire-summary-box h3,\n    .profile-summary-box h3 {\n      font-size: 1.25rem;\n    }\n    \n    .feature-item {\n      padding: var(--spacing-lg);\n    }\n    \n    .feature-item i {\n      font-size: 2.5rem;\n    }\n    \n    .feature-item h4 {\n      font-size: 1.1rem;\n    }\n    \n    .edit-questionnaire-button,\n    .edit-profile-button {\n      padding: var(--spacing-md) var(--spacing-lg);\n      font-size: 0.9rem;\n    }\n    \n    .payment-success h3 {\n      font-size: 1.5rem;\n      flex-direction: column;\n      gap: var(--spacing-sm);\n    }\n    \n    .blur-content::after {\n      font-size: 0.9rem;\n      padding: var(--spacing-md) var(--spacing-lg);\n    }\n  }\n  \n  /* ===== SCROLLBAR STYLING ===== */\n  .sidebar::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  .sidebar::-webkit-scrollbar-track {\n    background: var(--dark-surface);\n  }\n  \n  .sidebar::-webkit-scrollbar-thumb {\n    background: var(--border-color);\n    border-radius: 3px;\n  }\n  \n  .sidebar::-webkit-scrollbar-thumb:hover {\n    background: var(--primary-color);\n  }\n  \n  /* ===== LOADING STATES ===== */\n  .loading-spinner-small {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top: 2px solid var(--text-primary);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-right: var(--spacing-sm);\n  }\n  \n  /* ===== HOVER EFFECTS ===== */\n  .dashboard-card:hover h3 i {\n    transform: scale(1.2) rotate(5deg);\n    transition: all var(--transition-normal);\n  }\n  \n  .feature-item:hover i {\n    transform: scale(1.1) rotate(-5deg);\n    transition: all var(--transition-normal);\n  }\n  \n  /* ===== FOCUS STATES ===== */\n  .edit-questionnaire-button:focus,\n  .edit-profile-button:focus {\n    outline: 2px solid var(--primary-color);\n    outline-offset: 2px;\n  }\n  \n  /* ===== HIGH CONTRAST MODE ===== */\n  @media (prefers-contrast: high) {\n    :root {\n      --border-color: #ffffff;\n      --text-secondary: #ffffff;\n      --text-muted: #cccccc;\n    }\n  }\n  \n  /* ===== REDUCED MOTION ===== */\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n  /* Add these viewport handling rules to your existing CSS */\n\n/* ===== MOBILE RESPONSIVENESS - VIEWPORT HANDLING ONLY ===== */\n@media (max-width: 768px) {\n    .content {\n      margin-left: 0;\n      width: 100%;\n      min-width: 0;\n      overflow-x: hidden;\n    }\n    \n    .sidebar {\n      display: none;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .content {\n      padding: var(--spacing-md);\n      min-height: 100vh;\n    }\n    \n    .questionnaire-details {\n      grid-template-columns: 1fr;\n    }\n    \n    .profile-details {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  /* ===== ENSURE CONTENT IS ALWAYS VISIBLE ===== */\n  .dashboard-container {\n    min-height: 100vh;\n    overflow-x: hidden;\n  }\n  \n  .content {\n    min-height: 100vh;\n    position: relative;\n    z-index: 1;\n  }\n\n  @media (max-width: 768px) {\n    .dashboard-container {\n      flex-direction: column;\n    }\n    \n    .sidebar {\n      width: 100%;\n      height: auto;\n      position: static;\n      border-right: none;\n      border-bottom: 2px solid var(--border-color);\n    }\n    \n    .sidebar ul {\n      display: flex;\n      overflow-x: scroll;\n      padding: 10px;\n      margin: 0;\n    }\n    \n    .sidebar ul li {\n      flex: none;\n      margin: 0 5px;\n      padding: 10px 15px;\n      min-width: 80px;\n      text-align: center;\n    }\n    \n    .sidebar ul li span {\n      display: block;\n      font-size: 12px;\n    }\n    \n    .content {\n      margin-left: 0;\n    }\n  }\n  \n  \n  .dashboard-feature-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: var(--spacing-lg);\n    margin-top: var(--spacing-xl);\n  }\n  \n  .profile-details-subtitle {\n    text-align: center;\n    color: var(--text-secondary);\n    margin-bottom: var(--spacing-xl);\n  }\n  \n  .questionnaire-summary-subtitle {\n    text-align: center;\n    color: var(--text-secondary);\n    margin-bottom: var(--spacing-xl);\n  }\n\n\n  /* ============================================================\n   Recommendations.css\n   University Recommendations Panel Styling\n   ============================================================ */\n\n/* —— Color Variables —— */\n:root {\n  --primary: #377DFF;\n  --primary-dark: #265EDC;\n  --bg-page: #11151f;\n  --bg-panel: #1a1f2e;\n  --bg-card: #242837;\n  --bg-input: #1a1f2e;\n  --border: #3a3f57;\n  --text: #e0e2e7;\n  --text-muted: #999;\n}\n\n/* ============================================================\n   Filters Container\n   ============================================================ */\n.recommendations-filters {\n  background: var(--bg-panel);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n/* —— Field-of-Study Pills —— */\n.filter-pills {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.pill {\n  background: var(--bg-input);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 0.4rem 0.8rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.pill.active {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #fff;\n}\n\n/* —— Numeric & Text Inputs —— */\n.filter-inputs {\n  flex: 1 1 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 0.75rem;\n}\n.filter-item {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.85rem;\n  color: var(--text);\n}\n.filter-item label {\n  margin-bottom: 0.2rem;\n}\n.filter-item input {\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 0.4rem 0.6rem;\n  color: #fff;\n  transition: border-color 0.2s;\n}\n.filter-item input::placeholder {\n  color: var(--text-muted);\n}\n.filter-item input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n/* —— Search Button —— */\n.search-btn {\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  padding: 0.75rem 1.25rem;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n  align-self: flex-end;\n  flex: 0 0 auto;\n}\n.search-btn:hover {\n  background: var(--primary-dark);\n}\n/* push search to right on desktop */\n.recommendations-filters > .search-btn {\n  margin-left: auto;\n}\n\n/* ============================================================\n   Loading Bar\n   ============================================================ */\n.loading-bar {\n  position: relative;\n  height: 4px;\n  background: var(--border);\n  border-radius: 2px;\n  overflow: hidden;\n  margin: 1rem 0;\n}\n.loading-bar-progress {\n  position: absolute;\n  height: 100%;\n  width: 0;\n  background: var(--primary);\n  animation: loading 1s infinite;\n}\n@keyframes loading {\n  0%   { width: 0;   }\n  50%  { width: 80%; }\n  100% { width: 0;   }\n}\n\n/* ============================================================\n   University Cards Grid\n   ============================================================ */\n.universities-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 1rem;\n}\n.university-card {\n  background: var(--bg-card);\n  color: var(--text);\n  border-radius: 8px;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border);\n  transition: transform 0.2s, border-color 0.2s;\n  \n}\n.university-card:hover {\n  transform: translateY(-4px);\n  border-color: var(--primary);\n}\n.university-card h4 {\n  margin: 0 0 0.5rem;\n  font-size: 1.1rem;\n}\n.university-card .location {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  margin-bottom: 0.8rem;\n}\n.university-card p {\n  margin: 0.3rem 0;\n  font-size: 0.9rem;\n}\n\n/* —— Card Buttons —— */\n.card-buttons {\n  margin-top: auto;\n  display: flex;\n  gap: 0.5rem;\n}\n.budget-btn,\n.apply-btn {\n  flex: 1;\n  padding: 0.5rem;\n  font-size: 0.9rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.budget-btn {\n  background: var(--bg-input);\n  color: var(--text);\n}\n.budget-btn:hover {\n  background: var(--border);\n}\n.apply-btn {\n  background: var(--primary);\n  color: #fff;\n}\n.apply-btn:hover {\n  background: var(--primary-dark);\n}\n\n/* ============================================================\n   Budget Modal\n   ============================================================ */\n.budget-modal-backdrop {\n  /* cover the viewport */\n  position: fixed;\n  inset: 0;                        /* shorthand for top/right/bottom/left: 0 */\n  background: rgba(0,0,0,0.6);\n  \n  /* center its child */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* ensure it’s above everything else */\n  z-index: 1000;\n\n  /* allow scrolling inside on very small viewports */\n  padding: 20px;\n}\n\n.budget-modal {\n  /* remove any fixed/absolute positioning */\n  position: relative;\n\n  /* size & look */\n  background: var(--bg-panel);\n  padding: 2rem;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 400px;               /* or your desired width */\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.5);\n\n  /* make sure it never overflows the viewport */\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n}\n\n/* your close button etc. can stay exactly as before */\n.modal-close-btn {\n  position: absolute;\n  top: 0.5rem; right: 0.5rem;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.modal-close-btn:hover {\n  color: #fff;\n}\n.budget-modal h3 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n.budget-modal p {\n  margin: 0.5rem 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n.budget-modal hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 1rem 0;\n}\n\n/* —— No Matches Found —— */\n.no-results {\n  color: var(--text-muted);\n  font-style: italic;\n  margin-top: 1rem;\n}\n\n/* ============================================================\n   Responsive Breakpoints\n   ============================================================ */\n@media (max-width: 900px) {\n  .recommendations-filters {\n    gap: 0.75rem;\n  }\n  .filter-inputs {\n    grid-template-columns: repeat(auto-fill, minmax(120px,1fr));\n  }\n}\n\n@media (max-width: 600px) {\n  .recommendations-filters {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  .filter-inputs {\n    grid-template-columns: 1fr;\n  }\n  .search-btn {\n    width: 100%;\n    margin: 0;\n  }\n  .universities-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .pill {\n    font-size: 0.85rem;\n    padding: 0.35rem 0.7rem;\n  }\n}\n.invalid-input {\n  border: 1px solid #ff5b5b;\n  background-color: #2e1e1e;\n}\n.error-text {\n  color: #ff5b5b;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  background: #121827;\n  z-index: 1000;\n}\n\n\n\n\n.universities-list {\n  display: flex !important;\n  overflow-x: auto !important;\n  gap: 1rem !important;\n  padding-bottom: 1rem !important;\n  scroll-snap-type: x mandatory !important;\n  -webkit-overflow-scrolling: touch !important;\n}\n\n.universities-list::-webkit-scrollbar {\n  height: 6px !important;\n}\n\n.universities-list::-webkit-scrollbar-thumb {\n  background: rgba(59, 130, 246, 0.5) !important;\n  border-radius: 3px !important;\n}\n\n.university-card {\n  flex: 0 0 240px !important;\n  scroll-snap-align: start !important;\n}\n\n\n@media (max-width: 600px) {\n  .universities-list {\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    overflow-x: hidden !important;\n  }\n\n  .university-card {\n    flex: 1 1 100% !important;\n    scroll-snap-align: none !important;\n  }\n}\n\n.premium-advisor {\n  padding: 20px;\n  background: #1c1e2a;\n  border-radius: 10px;\n  color: white;\n}\n\n.mode-selector button,\n.premium-advisor button {\n  margin: 10px;\n  padding: 10px 20px;\n  background: #34a853;\n  border: none;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.upload-section input,\n.form-section input,\n.form-section textarea {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  padding: 8px;\n  border-radius: 5px;\n}\n\n.result-box {\n  margin-top: 20px;\n}\n.premium-advisor {\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 2rem;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background: #1a1f2e;\n}\ninput, textarea {\n  width: 100%;\n  padding: 10px;\n  margin: 0.5rem 0;\n}\nbutton {\n  padding: 10px 20px;\n  margin: 10px 5px;\n}\n.result-box, .error {\n  margin-top: 20px;\n}\n/* ─── Themed Hot-Offer Box ─────────────────────────────────────────── */\n.hot-offer-box {\n  background: #161b22;                   /* match your card bg */\n  border: 1px solid #30363d;             /* match your border color */\n  border-left: 4px solid #238636;        /* green accent, or pick your brand blue #58a6ff */\n  border-radius: 6px;\n  padding: 16px;\n  margin: 20px 0;\n  color: #c9d1d9;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.4);\n}\n.hot-offer-box h3 {\n  margin: 0 0 8px;\n  color: #58a6ff;                         /* your primary accent */\n}\n.hot-offer-box p {\n  margin: 4px 0;\n  color: #8b949e;                         /* muted text */\n}\n\n/* ─── Payment Card Tweaks ─────────────────────────────────────────── */\n.payment-card {\n  border: 1px solid #30363d;\n  background: #161b22;\n  color: #c9d1d9;\n}\n.payment-card h3 {\n  color: #58a6ff;\n}\n.paid-card {\n  text-align: center;\n}\n.paid-card i.fa-check-circle {\n  color: #238636;                        /* success green */\n  font-size: 1.5em;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n.paid-card p {\n  margin: 12px 0;\n}\n\n/* ─── “View Recommendations” button ───────────────────────────────── */\n.go-to-recs {\n  background: #58a6ff;\n  border: none;\n  color: #fff;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.95em;\n}\n.go-to-recs:hover {\n  background: #3a7bcc;\n}\n\n\n\n/* ─── Promo-Poster Card ─────────────────────────────────────────────── */\n\n.promo-card {\n  background: linear-gradient(135deg, #0d1117 0%, #161b22 100%);\n  border: 2px solid #30363d;\n  border-left: 6px solid #58a6ff;   /* your primary accent */\n  border-radius: 8px;\n  padding: 24px;\n  margin: 20px 0;\n  color: #c9d1d9;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.6);\n  text-align: center;\n}\n.promo-header {\n  font-size: 1.5em;\n  color: #58a6ff;\n  margin-bottom: 8px;\n}\n.promo-subtitle {\n  font-size: 1em;\n  color: #8b949e;\n  margin-bottom: 16px;\n  line-height: 1.4;\n}\n.promo-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n  text-align: left;\n  display: inline-block;\n}\n.promo-features li {\n  display: flex;\n  align-items: center;\n  margin: 8px 0;\n  font-size: 0.95em;\n}\n.promo-features li i {\n  color: #238636;  /* success-green accent */\n  margin-right: 10px;\n  font-size: 1.1em;\n}\n.promo-action {\n  margin-top: 12px;\n}\n/* If your PaymentSection renders a button, you can target it: */\n.promo-action button {\n  background: #58a6ff;\n  border: none;\n  color: #fff;\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n}\n.promo-action button:hover {\n  background: #3a7bcc;\n}\n\n\n\n\n\n\n/* Container spacing */\n#recommendations.tab-content {\n  padding: 16px 0 24px;\n}\n\n/* Premium section */\n.premium-section {\n  background: #0f1523;\n  border: 1px solid #2a3246;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 18px;\n}\n.premium-section h3 {\n  margin: 0 0 6px;\n}\n.premium-section p {\n  margin: 0 0 12px;\n  color: #b9c0d4;\n}\n\n/* Normal recommendations area */\n.recommendations-filters {\n  background: #0b1020;\n  border: 1px solid #252d41;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n.filter-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.filter-pills strong {\n  margin-right: 8px;\n  color: #9fb0d0;\n  font-weight: 600;\n}\n.pill {\n  border: 1px solid #2b3550;\n  background: #121a2f;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}\n.pill.active { outline: 2px solid #2e7d32; }\n\n.filter-inputs {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 12px;\n}\n@media (max-width: 980px) {\n  .filter-inputs { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 560px) {\n  .filter-inputs { grid-template-columns: 1fr; }\n}\n.filter-item label {\n  display: block;\n  font-size: 12px;\n  color: #8ea0c0;\n  margin-bottom: 4px;\n}\n.filter-item input {\n  width: 100%;\n  background: #0f172a;\n  border: 1px solid #29324a;\n  border-radius: 8px;\n  padding: 10px 12px;\n  color: #e6ecff;\n}\n.filter-item input.invalid-input {\n  border-color: #d33;\n}\n.error-text {\n  display: block;\n  margin-top: 4px;\n  color: #ff9b9b;\n  font-size: 12px;\n}\n\n.search-btn {\n  margin-top: 12px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 0;\n  background: #2563eb;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n}\n.search-btn:disabled { opacity: .5; cursor: not-allowed; }\n\n/* Loading bar */\n.loading-bar {\n  height: 6px;\n  border-radius: 999px;\n  background: #101626;\n  overflow: hidden;\n  margin: 12px 0 6px;\n}\n.loading-bar-progress {\n  width: 45%;\n  height: 100%;\n  background: linear-gradient(90deg, #2563eb, #22c55e);\n  animation: slide 1.2s infinite linear;\n}\n@keyframes slide {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(220%); }\n}\n\n/* Results grid */\n.universities-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n@media (max-width: 1100px) {\n  .universities-list { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 680px) {\n  .universities-list { grid-template-columns: 1fr; }\n}\n.university-card {\n  background: #0c1326;\n  border: 1px solid #24304b;\n  border-radius: 12px;\n  padding: 14px;\n}\n.university-card h4 { margin: 0 0 6px; }\n.university-card .location { color: #9fb0d0; margin: 0 0 8px; }\n.card-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n.budget-btn, .apply-btn {\n  flex: 1;\n  border: 0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n}\n.budget-btn { background: #1f2937; color: #dbeafe; }\n.apply-btn  { background: #22c55e; color: #0b1220; font-weight: 700; }\n\n/* Disabled normal UI when Premium */\n.normal-disabled {\n  position: relative;\n  opacity: .45;\n  pointer-events: none;   /* disables clicks inside */\n  filter: grayscale(0.2);\n}\n.normal-disabled .disabled-overlay {\n  pointer-events: none;\n  position: absolute;\n  inset: -6px -6px -6px -6px;\n  border-radius: 16px;\n  border: 1px dashed #34405c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #b6c3df;\n  font-size: 14px;\n}\n\n/* Budget modal */\n.budget-modal-backdrop {\n  position: fixed; inset: 0;\n  background: rgba(0,0,0,.5);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 999;\n}\n.budget-modal {\n  width: min(520px, 92vw);\n  background: #0f172a;\n  color: #e6ecff;\n  border: 1px solid #24304b;\n  border-radius: 12px;\n  padding: 16px;\n  position: relative;\n}\n.modal-close-btn {\n  position: absolute; top: 8px; right: 8px;\n  width: 32px; height: 32px; border-radius: 50%;\n  border: 1px solid #2b3550; background: #0b1220; color: #dbeafe;\n  cursor: pointer;\n}\n\n/* Small helpers */\n.no-results { color: #b9c0d4; margin-top: 8px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
